import _ from 'lodash'
import { PageArea, PageProps } from '../index'
import store, { AllState } from '../../../store'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import {
  acceptChild,
  ColumnQuickFilterKey,
  createNewProjectPlanNewRow,
  duplicateProjectPlanNewRow,
  duplicateProjectPlanNewRowNameOnly,
  filter,
  getEditedAncestor,
  NewWbsItemRow,
  ProjectPlanFilterRequest,
  ProjectPlanNewRow,
  SelectedColumnQuickFilterKey,
  SelectedColumnQuickFilterKeyType,
} from './projectPlanNew'
import { useProjectPlanNewGridOptions } from './gridOptions'
import { useExperiment } from '../../hooks/useExperiment'
import {
  BodyScrollEndEvent,
  CellClickedEvent,
  CellEditingStartedEvent,
  ColDef,
  ColumnState,
  ColumnVisibleEvent,
  DefaultMenuItem,
  FilterChangedEvent,
  FirstDataRenderedEvent,
  GetContextMenuItemsParams,
  GridApi,
  GridReadyEvent,
  MenuItemDef,
  ModelUpdatedEvent,
  RowDataUpdatedEvent,
  RowDragEvent,
  RowGroupOpenedEvent,
  IRowNode,
  SortChangedEvent,
  GridOptions,
} from 'ag-grid-community'
import { BulkSheetView } from '../../containers/BulkSheetView'
import { useBulkSheetState } from '../../containers/BulkSheetView/hooks/bulkSheetState/bulkSheetState'
import Loading from '../../components/process-state-notifications/Loading'
import { useDragTreeStyle } from '../../containers/BulkSheetView/hooks/gridEvents/treeRowDrag'
import {
  focusRow,
  allDescendants,
  getAllLeafChildren,
  getDisplayedRow,
  getRowNumber,
  getSelectedNode,
} from '../../containers/BulkSheetView/lib/gridApi'
import {
  useDialog,
  usePageState,
  usePopper,
  useProjectPlanNewData,
  useMilestoneData,
  useWbsItemDependencyData,
  useWbsItemCriticalPathData,
} from './hooks'
import { buildUuidToRowIndexMap } from './hooks/buildUuidToRowIndexMap'
import project from '../../../lib/functions/project'
import { exportExcel } from '../../containers/BulkSheet/excel'
import { intl } from '../../../i18n'
import { generateUuid } from '../../../utils/uuids'
import {
  addGlobalMessage,
  addScreenMessage,
  MessageLevel,
} from '../../../store/messages'
import { WbsItemStatus } from '../../containers/commons/AgGrid/components/cell/custom/wbsItemStatus'
import { sortByRowIndex } from '../../containers/BulkSheetView/lib/rowNode'
import {
  moveRowsToLastChild,
  slideRowsAfter,
  slideRowsBefore,
} from '../../containers/BulkSheetView/hooks/actions/moveTreeRows'
import {
  addRowsBefore,
  addRowsBelow,
  addRowsToLastChild,
  removeRows,
} from '../../containers/BulkSheetView/hooks/actions/crudTreeRows'
import {
  addRowAboveMenuItems,
  addRowsToChildMenuItems,
  addRowToChildMenuItems,
  addTicketMenuItems,
  addWorkgroupMenuItems,
  changeProcessToWorkgroupMenuItems,
  deleteRowMenuItems,
  duplicateSameNameTaskMenuItems,
  hasRowNodeAdded,
  hasRowNodeActualHourRegistered,
  hasRowNodeTicketListWithChild,
  reportMenuItems,
  switchRootWbsMenuItems,
} from './gridOptions/contextMenu'
import {
  addCopyURLAndNameMenuItems,
  addCopyURLMenuItems,
  copyAllTreeMenuItems,
  copyTreeMenuItems,
  cutTreeMenuItems,
  focusCellAfterCopy,
  groupRowMenuItems,
  pasteCutTreeMenuItems,
  pasteTreeMenuItems,
} from '../../containers/BulkSheetView/gridOptions/contextMenu'
import { DeleteRowConfirmationDialog } from '../../containers/BulkSheetView/components/dialog/DeleteRowConfirmationDialog'
import {
  GANTT_FIT_MIN_CONTENT_RATIO,
  getGanttChartWidth,
} from '../ProjectPlan/projectPlanOptions'
import { AddMultipleTicketDialog } from '../../components/dialogs/AddMultipleTicketDialog'
import TicketListAPI, {
  TicketListDetail,
} from '../../../lib/functions/ticketList'
import DateVO from '../../../vo/DateVO'
import TaskActualWorkDialog from '../../components/dialogs/TaskActualWorkDialog'
import { useKeyBind } from '../../hooks/useKeyBind'
import { KEY_ESC, KEY_SAVE, KEY_SPACE } from '../../model/keyBind'
import AddRowCountInputDialog from '../../containers/BulkSheet/AddRowCountInputDialog'
import MultiSelectDialog, {
  MultiSelectDialogSelection,
} from '../../components/dialogs/MultiSelectDialog'
import objects from '../../../utils/objects'
import { ProjectPlanCumulation } from '../../../lib/functions/projectPlan'
import { StatusChangePopper } from '../../components/poppers/StatusChangePopper'
import { WbsItemTypeVO } from '../../../domain/value-object/WbsItemTypeVO'
import { extractValuesFromResponse } from '../../../lib/commons/api'
import { handleWarning } from '../../../handlers/globalErrorHandler'
import CancelConfirmDialog from '../../components/dialogs/CancelConfirmDialog'
import { DateFilterOperator } from '../../containers/BulkSheetView/components/filter'
import { getParent } from '../../containers/BulkSheetView/lib/tree'
import { copyRows } from '../../containers/BulkSheetView/hooks/actions/copyTreeRows'
import appFunctionAPI, {
  ApplicationFunctionPropertyConfiguration,
} from '../../../lib/commons/appFunction'
import BoolExpression from '../../../utils/boolExpression'
import { GanttParameterVO } from '../../../domain/value-object/GanttParameterVO'
import { projectPrivate } from '../../higher-order-components/projectPrivate'
import { connect } from 'react-redux'
import { generateGanttScale } from '../../containers/commons/AgGrid/components/cell/custom/gantt/ganttUtil'
import { ProgressLineOverlay } from '../../containers/commons/AgGrid/components/cell/custom/gantt/ProgressLineOverlay'
import {
  InputError,
  validateNodes,
} from '../../containers/BulkSheetView/lib/validation'
import { useProjectPrivateContext } from '../../context/projectContext'
import SavedUIStateDialog from '../../components/dialogs/SavedUIStateDialog'
import uiStates, {
  UiStateKey,
  UiStateScope,
} from '../../../lib/commons/uiStates'
import { SavedUIState } from '../../components/dialogs/SavedUIStateDialog/SavedUIStateList'
import { ReportReCalculator } from './gridOptions/cumulation'
import '../../../styles/agGrid.scss'
import { TagForWbsItem } from '../../../lib/functions/tag'
import { useWorkloadUnit } from '../../hooks/useWorkloadUnit'
import ProjectPlanNewWbsHeader from './components/Header/ProjectPlanNewWbsHeader'
import { WbsItemLinkDialog } from '../../containers/commons/AgGrid/components/cell/custom/gantt/CellRenderer/WbsItemLink/WbsItemLinkDialog'
import ProjectPlanNewReport from './components/Header/ProjectPlanNewReport'
import ColumnSettingPopper from '../../containers/BulkSheetView/components/columnSelector/ColumnSettingPopper'
import SavePopper from '../../containers/BulkSheetView/components/header/SaveButtonArea'
import ProjectPlanNewBreadcrumb from './components/Header/ProjectPlanNewBreadcrumb'
import { useColumnSetting } from '../../containers/BulkSheetView/components/columnSelector/useColumnSetting'
import { FunctionLayer } from '../../../store/functionLayer'
import { SortedColumnState } from '../../model/bulkSheetColumnSortState'
import AlertDialog from '../../components/dialogs/AlertDialog'
import usePrevious from '../../hooks/usePrevious'
import { GanttChartProvider } from '../../containers/BulkSheetView/GanttChartProvider'
import { useLocation } from 'react-router'
import {
  runAsyncWithPerfMonitoring,
  runWithPerfMonitoring,
} from '../../../utils/monitoring'
import { needToOpenInNewTab } from '../../router'
import {
  UnsavedTicketDetail,
  openUnsavedTicketSingleSheetDialog,
} from '../Ticket/ticket'
import { doNotRequireSave, requireSave } from '../../../store/requiredSaveData'
import { useWbsItemAdditionalPropertiesOfBaseWbsItemTypes } from '../../hooks/useWbsItemAdditionalProperties'
import { WbsItemAdditionalPropertyLayoutEntity } from '../../../domain/entity/WbsItemAdditionalPropertyLayoutEntity'
import {
  FIELD_WBSITEM_ACTUALDATE_END,
  FIELD_WBSITEM_ACTUALDATE_START,
  FIELD_WBSITEM_ACTUALHOUR,
} from './gridOptions/defaultColumns'
import ActionPopper from './components/ActionPopper'
import { useActionPopper } from './hooks/actionPopper'
import { changeGanttParameter } from '../../../store/project'
import { useGanttEditTarget } from './hooks/ganttEditTarget'
import { useWbsItemCodeService } from '../../../services/adaptors/wbsItemCodeServiceAdaptor'
import {
  WbsItemSelectColumnOptionType,
  useWbsItemSelectColumnOptions,
} from '../../hooks/useWbsItemSelectColumnOptions'
import { featureFlagService } from '../../../utils/feature-flag'
import { useExcelImport } from './hooks/excel'
import { WbsItemRow } from '../../../lib/functions/wbsItem'
import { useGridContext } from '../../containers/BulkSheetView/hooks/useGridContext'

const mapStateToProps = (state: AllState) => ({
  ganttParameter: state.project.ganttParameter,
  tag: state.tag[state.project.selected ?? ''] ?? [],
  functionLayers: state.functionLayer.layers,
  edited: state.hasRequiredSaveData.hasRequiredSaveData,
})

type StateProps = {
  ganttParameter?: GanttParameterVO
  tags: TagForWbsItem[]
  functionLayers: Immutable.Map<number, FunctionLayer>
  edited: boolean
}
type WrapperProps = PageProps & StateProps

export enum QuickFilterKeys {
  ALL = 'ALL',
  START_BY_TODAY = 'START_BY_TODAY',
  END_BY_TODAY = 'END_BY_TODAY',
  START_DELAYED = 'START_DELAYED',
  END_DELAYED = 'END_DELAYED',
}

const fetchPropertyConfigurations = async (
  functionUuid: string,
  projectUuid: string
): Promise<ApplicationFunctionPropertyConfiguration[]> => {
  const response = await appFunctionAPI.getPropertyConfiguraitons(
    functionUuid,
    [projectUuid]
  )
  return response.json.map(v => ({
    ...v,
    requiredIf: v.requiredIf ? BoolExpression.of(v.requiredIf) : undefined,
    editableIfC: v.editableIfC ? BoolExpression.of(v.editableIfC) : undefined,
    editableIfU: v.editableIfU ? BoolExpression.of(v.editableIfU) : undefined,
    hiddenIfC: v.hiddenIfC ? BoolExpression.of(v.hiddenIfC) : undefined,
    hiddenIfU: v.hiddenIfU ? BoolExpression.of(v.hiddenIfU) : undefined,
  })) as ApplicationFunctionPropertyConfiguration[]
}

export const ProjectPlanNew = connect(mapStateToProps)(
  projectPrivate(
    ({
      uuid: functionUuid,
      ganttParameter,
      tags,
      functionLayers,
      edited,
    }: WrapperProps) => {
      const { project } = useProjectPrivateContext()
      const [propertyConfigurations, setPropertyConfigurations] =
        useState<ApplicationFunctionPropertyConfiguration[]>()
      useEffect(() => {
        const init = async () => {
          const propertyConfigurations = await fetchPropertyConfigurations(
            functionUuid,
            project.uuid
          )
          setPropertyConfigurations(propertyConfigurations)
        }
        init()
      }, [functionUuid, project.uuid])
      const { search } = useLocation()
      const treeRootUuid = useMemo(() => {
        const params = new URLSearchParams(search)
        return params.get('treeRootUuid') || undefined
      }, [search])
      const {
        fetched: wbsItemAdditionalPropertyInitialized,
        wbsItemAdditionalProperties,
      } = useWbsItemAdditionalPropertiesOfBaseWbsItemTypes()

      const { selectColumnOptions, fetchedSelectColumnOptions } =
        useWbsItemSelectColumnOptions({
          projectUuid: project.uuid,
        })

      const selectOptions = useMemo(
        () =>
          fetchedSelectColumnOptions
            ? {
                ...selectColumnOptions,
              }
            : undefined,
        [selectColumnOptions, fetchedSelectColumnOptions]
      )

      // The last condition should be unnecessary, but somehow eslint does not work right.
      if (
        !wbsItemAdditionalPropertyInitialized ||
        !propertyConfigurations ||
        !ganttParameter ||
        !fetchedSelectColumnOptions
      ) {
        return <></>
      }
      return (
        <ProjectPlanNewContent
          projectUuid={project.uuid}
          treeRootUuid={treeRootUuid}
          functionUuid={functionUuid}
          propertyConfigurations={propertyConfigurations}
          ganttParameter={ganttParameter}
          tags={tags}
          layers={functionLayers}
          edited={edited}
          wbsItemAdditionalProperties={wbsItemAdditionalProperties}
          selectColumnOptions={selectOptions}
        />
      )
    }
  )
)

type Props = {
  projectUuid: string
  treeRootUuid?: string
  functionUuid: string
  propertyConfigurations: ApplicationFunctionPropertyConfiguration[]
  ganttParameter: GanttParameterVO
  tags: TagForWbsItem[]
  layers: Immutable.Map<number, FunctionLayer>
  edited: boolean
  selectColumnOptions: WbsItemSelectColumnOptionType
  wbsItemAdditionalProperties?: WbsItemAdditionalPropertyLayoutEntity
}

const ProjectPlanNewContent = ({
  projectUuid,
  treeRootUuid,
  functionUuid,
  propertyConfigurations,
  ganttParameter,
  tags,
  layers,
  edited,
  selectColumnOptions,
  wbsItemAdditionalProperties,
}: Props) => {
  const [loading, setLoading] = useState<boolean>(true)
  const ref = useRef<HTMLDivElement>(null)
  const [outputExcel, setOutputExcel] = useState(false)
  const [exportColIds, setExportColIds] = useState<string[]>([])
  const gridApiRef = useRef<GridApi>()
  const [isGridReady, setIsGridReady] = useState(false)

  const [changeLength, setChangeLength] = useState<number>(0)
  const { generateCode } = useWbsItemCodeService()
  const useSprintsMultiSelect = featureFlagService.isEnabled(
    'sprints-multi-select'
  )
  const isGanttV2 = featureFlagService.isEnabled('gantt-v2')
  // Project plan data
  const {
    data,
    setData,
    enqueue,
    refresh,
    refreshRow,
    generateUpdateWbsItemDeltaRequest,
    save,
    saveSingleRow,
    deleteRows,
    deletedRows,
    rootProjectPlanUuid,
    rootWbsItem,
    switchRootWbsItem: _switchRootWbsItem,
    setProjectPlanBody,
    fetchBodyByCode,
    isFetchingBody,
  } = useProjectPlanNewData(projectUuid, treeRootUuid, useSprintsMultiSelect)
  const treeChangedCount = useRef<number>(0)

  const handleWbsItemUpdate = useCallback(
    (updatedWbsItem: NewWbsItemRow | WbsItemRow) => {
      const currentData = prevData.current
      const row = currentData.find(
        r => r.body?.wbsItem?.uuid === updatedWbsItem.uuid
      )
      if (row) {
        const uuidsToRefresh = [row.uuid]
        const updatedRowIndex = row.treeValue.findIndex(
          uuid => uuid === row.uuid
        )
        if (updatedRowIndex > 0) {
          uuidsToRefresh.push(...row.treeValue.slice(0, updatedRowIndex))
        }
        enqueue(uuidsToRefresh)
        if (
          prevData.current.filter(
            v => v.uuid !== row.uuid && (v.edited || v.added)
          ).length === 0
        ) {
          store.dispatch(doNotRequireSave())
        }
      }
    },
    [enqueue]
  )

  // Read state in event listener
  const submit = useRef<Function>()
  submit.current = save
  const reload = useRef<Function>()
  reload.current = refresh
  const saveSingleRowFunc =
    useRef<(uuid: string) => Promise<boolean | undefined>>()
  useEffect(() => {
    saveSingleRowFunc.current = saveSingleRow
  }, [saveSingleRow])

  // Stored state
  const pageState = usePageState(functionUuid)
  const bulkSheetState = useBulkSheetState(
    functionUuid,
    projectUuid,
    undefined,
    undefined
  )

  const savedUIStateRef = useRef<Record<string, unknown>>({})
  savedUIStateRef.current.columnState = bulkSheetState.columnState
  savedUIStateRef.current.filterState = bulkSheetState.filterState
  if (isGanttV2) {
    savedUIStateRef.current.ganttParameter = (
      ganttParameter ?? GanttParameterVO.defaultValue()
    ).serialize()
  }

  const dialog = useDialog()
  const popper = usePopper()
  const columnSetting = useColumnSetting()
  const [filteredColumns, setFilteredColumns] = useState<ColDef[]>([])
  const [gantt, showGantt] = useState<boolean>(false)
  const isRowHeightFixed = gantt && featureFlagService.isEnabled('gantt-v2')
  const [quickFilters, setQuickFilters] = useState<QuickFilterKeys | undefined>(
    undefined
  )

  const [sortColumnsState, setSortColumnsState] = useState<SortedColumnState[]>(
    []
  )

  const {
    milestones,
    isLoadingMilestones,
    fetchMilestones,
    isMilestoneEnabled,
  } = useMilestoneData()

  const prevData = useRef<ProjectPlanNewRow[]>([])
  prevData.current = data

  const { hasUnsavedChanges: hasUnsavedDependencyChanges, ...dependencyData } =
    useWbsItemDependencyData()
  const {
    hasUnsavedChanges: hasUnsavedCriticalPathChanges,
    ...criticalPathData
  } = useWbsItemCriticalPathData()

  const hasChanged = useCallback((): boolean => {
    return (
      (prevData.current || data).some(v => v.added || v.edited) ||
      hasUnsavedDependencyChanges() ||
      hasUnsavedCriticalPathChanges()
    )
  }, [data, hasUnsavedDependencyChanges, hasUnsavedCriticalPathChanges])

  const tmpNewRootProjectPlanUuid = useRef<string | undefined>(undefined)
  const switchRootWbsItem = useCallback(
    async (
      newRootProjectPlanUuid: string | undefined,
      openInNewTab?: boolean
    ) => {
      if (openInNewTab) {
        const res = await project.getDetail({ uuid: projectUuid })
        const url = `${window.location.origin}/projectPlan/${res.json.code}${
          newRootProjectPlanUuid
            ? `?treeRootUuid=${newRootProjectPlanUuid}`
            : ''
        }`
        window.open(url)
        return
      }
      if (hasChanged()) {
        tmpNewRootProjectPlanUuid.current = newRootProjectPlanUuid
        dialog.openAlert()
      } else {
        _switchRootWbsItem(newRootProjectPlanUuid)
      }
    },
    [_switchRootWbsItem, dialog, hasChanged, projectUuid]
  )
  const onConfirmSwitchRootWbsItem = useCallback(() => {
    const newRootProjectPlanUuid = tmpNewRootProjectPlanUuid.current
    tmpNewRootProjectPlanUuid.current = undefined
    dialog.closeAlert()
    _switchRootWbsItem(newRootProjectPlanUuid)
  }, [_switchRootWbsItem, dialog])
  const onCancelSwitchRootWbsItem = useCallback(() => {
    tmpNewRootProjectPlanUuid.current = undefined
    dialog.closeAlert()
  }, [dialog])

  const gridOptionsRef = useRef<GridOptions | undefined>()
  const onChangeRowHeight = useCallback(
    (value: number) => {
      if (isRowHeightFixed) {
        gridApiRef.current?.resetRowHeights()
        return
      }
      pageState.setRowHeight(value)
      gridApiRef.current?.refreshCells({
        force: true,
        columns: ['ganttChart'],
      })
    },
    [pageState, isRowHeightFixed]
  )

  const deleteTargetNodesRef = useRef<IRowNode[]>([])
  const isOpenWbsItemDetail = useRef<boolean>(false)

  const submitSingleRowRef =
    useRef<(uuid: string) => Promise<boolean | undefined>>()

  const refreshWbsItem = useCallback(
    (wbsItemUuid: string) => {
      const row = prevData.current.find(
        row => row.body?.wbsItem?.uuid === wbsItemUuid
      )
      if (row) {
        const uuidsToRefresh = [row.uuid]
        const updatedRowIndex = row.treeValue.findIndex(
          uuid => uuid === row.uuid
        )
        if (updatedRowIndex > 0) {
          uuidsToRefresh.push(...row.treeValue.slice(0, updatedRowIndex))
        }
        refreshRow(prevData.current, uuidsToRefresh)
      }
    },
    [refreshRow]
  )

  const refreshWbsItemRef = useRef<(uuid: string) => void>(refreshWbsItem)
  useEffect(() => {
    refreshWbsItemRef.current = refreshWbsItem
  }, [refreshWbsItem])

  const ganttEditTargetNodeSelection = useGanttEditTarget()

  // 実験設定: ステータス列レイアウト
  // feature flag が有効な場合のみ実験を行う
  const isStatusCellNewEnabled = featureFlagService.isEnabled(
    'wbs-item-status-cell-new'
  )
  const { useNew: useNewStatusColumnLayout } = useExperiment(
    'wbs-status-column-layout',
    isStatusCellNewEnabled
  )

  const gridOptions = useProjectPlanNewGridOptions({
    projectUuid,
    switchRootWbsItem: (event: MouseEvent, rootProjectPlanUuid?: string) => {
      switchRootWbsItem(rootProjectPlanUuid, needToOpenInNewTab(event))
    },
    refreshWbsItem: refreshWbsItemRef,
    submitSingleRow: submitSingleRowRef,
    updateRows: (rows: ProjectPlanNewRow[], report?: boolean) => {
      const d = prevData.current.concat()
      rows.forEach(row => {
        if (!report) {
          row.edited = true
        }
        const i = d.findIndex(v => v.uuid === row.uuid)
        if (-1 < i) {
          d.splice(i, 1, row)
        }
      })
      setData(d)
    },
    addRowToChild: (type: WbsItemTypeVO, parentUuid) => {
      const added = createNewProjectPlanNewRow(type, generateCode)
      let newData = addRowsToLastChild(prevData.current, [added], parentUuid)
      setData(newData)
      const newRow = newData.find(v => v.uuid === added.uuid)!
      addCumulationToAncestors([newRow])
      gridApiRef.current?.getRowNode(parentUuid)?.setExpanded(true)
    },
    propertyConfigurations,
    wbsItemAdditionalProperties,
    onChangeRowHeight,
    openWbsDetailDialog: () => {
      isOpenWbsItemDetail.current = true
      actionPopper.close()
    },
    closeWbsDetailDialog: () => {
      isOpenWbsItemDetail.current = false
    },
    ganttEditTargetNodeSelection,
    selectColumnOptions,
    useSeparatedStatusColumn: useNewStatusColumnLayout,
    isMilestoneEnabled,
    useSprintsMultiSelect,
  })

  const { contextRef, updateContext } = useGridContext(
    gridApiRef.current,
    gridOptions.context
  )

  const [criticalPathDialogOpen, setCriticalPathDialogOpen] = useState(false)

  const validateSingleRow = useCallback(
    (uuid: string, data: ProjectPlanNewRow[]) => {
      const allParentItems = getEditedAncestor(uuid, data)
      const treeUuid: string[] = allParentItems.map(treeItem => treeItem.uuid)
      const errors = validateNodes({
        gridApi: gridApiRef.current,
        uuids: treeUuid,
      })

      return errors
    },
    []
  )

  const submitSingleRow = useCallback(
    async (uuid: string): Promise<boolean | undefined> => {
      const data = prevData.current
      const errors = validateSingleRow(uuid, data)
      if (errors?.hasMessage()) {
        store.dispatch(
          addGlobalMessage({
            type: MessageLevel.WARN,
            title: intl.formatMessage({ id: 'global.warning.businessError' }),
            text: errors.toMessage(id => {
              const node = gridApiRef.current?.getRowNode(id)
              return getRowNumber(node).toString()
            }),
          })
        )
        return false
      }
      await saveSingleRowFunc.current?.(uuid)
      return true
    },
    [validateSingleRow]
  )

  useEffect(() => {
    submitSingleRowRef.current = submitSingleRow
  }, [submitSingleRow])

  const groupDefaultExpanded = useMemo(
    () => (treeRootUuid ? 1 : 0),
    [treeRootUuid]
  )

  const addCumulationToAncestors = useCallback(
    (rows: ProjectPlanNewRow[]): void => {
      const ancestors = {}
      rows.forEach(row => {
        const ancestorNodes = (row.treeValue ?? [])
          .slice(0, -1)
          .map(id => gridApiRef.current?.getRowNode(id))
          .filter(v => v) as IRowNode[]
        ReportReCalculator.add(
          row,
          ancestorNodes.map(a => ancestors[a.id!] ?? a.data)
        ).forEach(added => {
          ancestors[added.uuid] = added
        })
      })
      for (const key in ancestors) {
        const node = gridApiRef.current?.getRowNode(key)
        node?.setData(ancestors[key])
      }
    },
    []
  )

  const deleteCumulationFromAncestors = useCallback(
    (rows: ProjectPlanNewRow[]): void => {
      const ancestors = {}
      rows.forEach(row => {
        const ancestorNodes = (row.treeValue ?? [])
          .slice(0, -1)
          .map(id => gridApiRef.current?.getRowNode(id))
          .filter(v => v) as IRowNode[]
        ReportReCalculator.delete(
          row,
          ancestorNodes.map(a => ancestors[a.id!] ?? a.data)
        ).forEach(subtracted => {
          ancestors[subtracted.uuid] = subtracted
        })
      })
      for (const key in ancestors) {
        const node = gridApiRef.current?.getRowNode(key)
        node?.setData(ancestors[key])
      }
    },
    []
  )

  useEffect(() => {
    updateContext({
      projectUuid,
      errors: new InputError(),
    })
  }, [updateContext])

  useEffect(() => {
    updateContext({
      rootProjectPlan: {
        ...contextRef.current.rootProjectPlan,
        uuid: rootProjectPlanUuid,
      },
    })
  }, [rootProjectPlanUuid, updateContext])

  useEffect(() => {
    if (rootWbsItem && rootWbsItem.displayName) {
      document.title = rootWbsItem.displayName
    }
  }, [rootWbsItem])

  useEffect(() => {
    updateContext({
      dateFormat: pageState.dateFormat,
    })
    gridApiRef.current?.refreshCells()
  }, [pageState.dateFormat, updateContext])

  useEffect(() => {
    const rafId = requestAnimationFrame(() => {
      gridApiRef.current?.resetRowHeights()
      if (gridApiRef.current?.getColumnDef('ag-Grid-AutoColumn')) {
        gridApiRef.current?.refreshCells({
          columns: ['ag-Grid-AutoColumn'],
          force: true,
        })
      }
    })
    return () => cancelAnimationFrame(rafId)
  }, [pageState.rowHeight])

  const workloadUnitState = useWorkloadUnit(pageState.workloadUnit)
  useEffect(() => {
    updateContext({
      aggregateTarget: pageState.aggregateTarget,
      aggregateField: pageState.aggregateField,
      workloadUnit: pageState.workloadUnit,
      workloadUnitState,
    })
    gridApiRef.current?.refreshCells({ force: true })
  }, [
    pageState.aggregateTarget,
    pageState.aggregateField,
    pageState.workloadUnit,
    workloadUnitState,
    updateContext,
  ])

  const quickFilterUuidsRef = useRef<Set<string> | undefined>(undefined)

  const isExternalFilterPresent = useCallback(() => {
    return quickFilterUuidsRef.current !== undefined
  }, [])

  const doesExternalFilterPass = useCallback((node: IRowNode) => {
    if (node.data?.added) return true
    if (!quickFilterUuidsRef.current) return true
    return node.id ? quickFilterUuidsRef.current.has(node.id) : false
  }, [])

  const filterByQuickFilters = useCallback(
    async (filters?: QuickFilterKeys, resetFilter?: boolean) => {
      if (!filters || filters === QuickFilterKeys.ALL) {
        quickFilterUuidsRef.current = undefined
        gridApiRef.current?.onFilterChanged()
        return
      }
      const request: ProjectPlanFilterRequest = { projectUuid }
      if (filters === QuickFilterKeys.START_BY_TODAY) {
        request.scheduledStartDate = {
          operator: DateFilterOperator.BEFORE,
          value: DateVO.now().serialize(),
        }
      }
      if (filters === QuickFilterKeys.END_BY_TODAY) {
        request.scheduledEndDate = {
          operator: DateFilterOperator.BEFORE,
          value: DateVO.now().serialize(),
        }
      }
      if (filters === QuickFilterKeys.START_DELAYED) {
        request.status = {
          values: [WbsItemStatus.TODO],
          includeBlank: false,
        }
        request.scheduledStartDate = {
          operator: DateFilterOperator.BEFORE,
          value: DateVO.now().subtractDays(1).serialize(),
        }
      }
      if (filters === QuickFilterKeys.END_DELAYED) {
        request.status = {
          values: [
            WbsItemStatus.TODO,
            WbsItemStatus.DOING,
            WbsItemStatus.REVIEW,
          ],
          includeBlank: false,
        }
        request.scheduledEndDate = {
          operator: DateFilterOperator.BEFORE,
          value: DateVO.now().subtractDays(1).serialize(),
        }
      }
      const response = await filter(request)
      quickFilterUuidsRef.current = new Set(response.json as string[])
      gridApiRef.current?.onFilterChanged()
    },
    [projectUuid]
  )

  useEffect(() => {
    filterByQuickFilters(quickFilters, false)
  }, [quickFilters, filterByQuickFilters])

  const [reportCumulation, setReportCumulation] =
    useState<ProjectPlanCumulation>(new ProjectPlanCumulation())
  const refreshReport = useMemo(() => {
    return _.debounce(
      () =>
        setReportCumulation(
          ProjectPlanCumulation.sum(
            data
              .filter(v => v.treeValue.length === 1 && !!v.body?.cumulation)
              .map(v => v.body!.cumulation) as ProjectPlanCumulation[]
          )
        ),
      500
    )
  }, [data])
  useEffect(() => refreshReport(), [data])

  const getAddRowTargetRowNode = useCallback(
    (api: GridApi, targetRowUuid?: string | undefined) => {
      if (!api) return
      if (!targetRowUuid) {
        const cell = api.getFocusedCell()
        return cell ? api.getDisplayedRowAtIndex(cell.rowIndex) : undefined
      }
      return api.getRowNode(targetRowUuid)
    },
    []
  )

  const addRow = useCallback(
    (
      type: WbsItemTypeVO,
      ticketListUuid?: string | undefined,
      direction?: 'Above' | 'Below',
      targetRowUuid?: string | undefined,
      focusNewRow: boolean = true
    ) => {
      if (!gridApiRef.current) return

      const selectedNode: IRowNode<ProjectPlanNewRow> | undefined =
        getAddRowTargetRowNode(gridApiRef.current, targetRowUuid)
      const selected = selectedNode?.data
      if (!selected) return
      const parentType = getParent(prevData.current, selected)?.body?.wbsItem
        ?.wbsItemType
      if (!parentType || !type.canBeChildOf(parentType)) return
      const newRow = createNewProjectPlanNewRow(
        type,
        generateCode,
        ticketListUuid
      )
      const newData =
        direction === 'Above'
          ? addRowsBefore(prevData.current, [newRow], selected.uuid)
          : addRowsBelow(prevData.current, [newRow], selected.uuid)
      setData(newData)
      addCumulationToAncestors(newData.filter(v => v.uuid === newRow.uuid))
      focusNewRow && focusRow(gridApiRef.current, newRow.uuid)
    },
    [getAddRowTargetRowNode, addCumulationToAncestors]
  )

  const addAbove = useCallback(
    (
      type: WbsItemTypeVO,
      ticketListUuid?: string,
      targetRowUuid?: string | undefined,
      focusNewRow: boolean = true
    ) => {
      addRow(type, ticketListUuid, 'Above', targetRowUuid, focusNewRow)
    },
    [addRow]
  )

  const addBelow = useCallback(
    (
      type: WbsItemTypeVO,
      ticketListUuid?: string,
      targetRowUuid?: string | undefined,
      focusNewRow: boolean = true
    ) => {
      addRow(type, ticketListUuid, 'Below', targetRowUuid, focusNewRow)
    },
    [addRow]
  )

  const addToChild = useCallback(
    (
      type: WbsItemTypeVO,
      ticketListUuid?: string,
      targetRowUuid?: string | undefined
    ) => {
      if (!gridApiRef.current) return
      const selectedNode: IRowNode<ProjectPlanNewRow> | undefined =
        getAddRowTargetRowNode(gridApiRef.current, targetRowUuid)
      const selected = selectedNode?.data
      const parentType = selected?.body?.wbsItem.wbsItemType
      if (!selected || !parentType || !type.canBeChildOf(parentType)) return
      const newRow = createNewProjectPlanNewRow(
        type,
        generateCode,
        ticketListUuid
      )
      const newData = addRowsToLastChild(
        prevData.current,
        [newRow],
        selected.uuid
      )
      setData(newData)
      addCumulationToAncestors(newData.filter(v => v.uuid === newRow.uuid))
      setTimeout(() => {
        gridApiRef.current?.getRowNode(selected.uuid)?.setExpanded(true)
      }, 0)
    },
    [getAddRowTargetRowNode, setData, addCumulationToAncestors]
  )

  const wbsItemTypes = useMemo(() => store.getState().project.wbsItemTypes, [])

  const actionPopper = useActionPopper({
    gridApi: gridApiRef.current,
    wbsItemTypes,
    addRowAbove: addAbove,
    addRowBelow: addBelow,
    addToChildRow: addToChild,
  })

  const removeRow = useCallback(() => {
    if (!gridApiRef.current) return
    const selectedNodes = getSelectedNode(gridApiRef.current)
    deleteTargetNodesRef.current = selectedNodes

    const openDialogAfterQueue = () => {
      setTimeout(() => {
        if (!gridApiRef.current) return
        const nodes = getAllLeafChildren(deleteTargetNodesRef.current)
        if (nodes.some(v => !v.data.body?.wbsItem?.uuid)) {
          openDialogAfterQueue()
        } else {
          dialog.openDeleteConfirmation()
        }
      }, 300)
    }

    const hasAddedNodes = hasRowNodeAdded(selectedNodes)
    const hasActualHourRegistered =
      hasRowNodeActualHourRegistered(selectedNodes)
    const hasTicketListWithChild = hasRowNodeTicketListWithChild(selectedNodes)

    const canDelete =
      hasAddedNodes || (!hasActualHourRegistered && !hasTicketListWithChild)
    if (!canDelete) return
    const allNodes = getAllLeafChildren(selectedNodes)
    const unexpandedNodes = allNodes.filter(v => !v.data.body?.wbsItem?.uuid)
    if (0 < unexpandedNodes.length) {
      enqueue(unexpandedNodes.map(v => v.data.uuid))
      openDialogAfterQueue()
      return
    }
    dialog.openDeleteConfirmation()
  }, [])

  const treeRootProjectPlans = useCallback(
    (rows: ProjectPlanNewRow[]): ProjectPlanNewRow[] => {
      return rows.filter(row => {
        const parentUuid = row.treeValue[row.treeValue.length - 2]
        return !rows.some(p => p.uuid === parentUuid)
      })
    },
    []
  )

  const validateCopy = useCallback((nodes: IRowNode[]) => {
    const rootWbsItems = treeRootProjectPlans(nodes.map(node => node.data))
      .map(v => v.body?.wbsItem)
      .filter(v => v) as NewWbsItemRow[]
    return (
      rootWbsItems.every(v => v.wbsItemType.isWorkgroup()) ||
      rootWbsItems.every(
        v =>
          v.wbsItemType.isProcess() ||
          v.wbsItemType.isDeliverableList() ||
          v.wbsItemType.isDeliverable()
      ) ||
      _.uniq(rootWbsItems.map(v => v.wbsItemType.code)).length === 1
    )
  }, [])

  const copyRow = useCallback(
    (cut?: boolean) => {
      const selectedNodes = gridApiRef.current
        ? getSelectedNode(gridApiRef.current)
        : undefined
      if (
        !gridApiRef.current ||
        !selectedNodes ||
        !validateCopy(selectedNodes)
      ) {
        return
      }
      const currentCopiedNodes =
        contextRef.current.copied?.map(v =>
          gridApiRef.current!.getRowNode(v.id)
        ) ?? []
      const copied = copyRows(
        prevData.current,
        selectedNodes.map(node => node.data),
        cut
      )
      updateContext({ copied })
      gridApiRef.current.redrawRows({
        rowNodes: [...currentCopiedNodes, ...selectedNodes].filter(v => !!v),
      })
      focusCellAfterCopy(gridApiRef.current)
    },
    [updateContext]
  )

  const validatePaste = useCallback((nodes: IRowNode[]) => {
    const selectedWbsItems: NewWbsItemRow[] = nodes
      .map(v => v.data?.body?.wbsItem)
      .filter(v => !!v)
    const copiedRows =
      contextRef.current.copied
        ?.map(v => prevData.current.find(d => d.uuid === v.id))
        .filter(v => v) ?? []
    const copiedWbsItems = treeRootProjectPlans(copiedRows)
      .map(v => v.body?.wbsItem)
      .filter(v => v) as NewWbsItemRow[]
    return (
      !_.isEmpty(copiedWbsItems) &&
      !_.isEmpty(selectedWbsItems) &&
      copiedWbsItems.every(c =>
        selectedWbsItems.every(p => c.wbsItemType.canBeChildOf(p.wbsItemType))
      )
    )
  }, [])

  const pasteRow = useCallback(() => {
    const selectedNodes = gridApiRef.current
      ? getSelectedNode(gridApiRef.current)
      : undefined
    if (
      !contextRef.current.copied?.every(v => !v.cut) ||
      !selectedNodes ||
      !validatePaste(selectedNodes)
    ) {
      return
    }
    dialog.openColumnSelect()
  }, [])

  const pasteRows = useCallback(
    (duplicate: (row: ProjectPlanNewRow) => ProjectPlanNewRow) => {
      const copied = contextRef.current.copied
      const selectedNodes = gridApiRef.current
        ? getSelectedNode(gridApiRef.current)
        : undefined
      if (
        !gridApiRef.current ||
        !selectedNodes ||
        !copied?.every(v => !v.cut) ||
        !validatePaste(selectedNodes)
      ) {
        return
      }
      let result = prevData.current.concat()
      const copiedRows = result.filter(v => copied.some(c => c.id === v.uuid))
      const treeUuids = treeRootProjectPlans(copiedRows).map(v => v.uuid)
      const treeMap: { [uuid: string]: string[] } = {}
      copiedRows.forEach(c => {
        const root = treeUuids.find(t => c.treeValue.includes(t))
        if (!root) return
        const rootIndex = c.treeValue.findIndex(uuid => root === uuid)
        treeMap[c.uuid] = c.treeValue.slice(rootIndex)
      })
      let firstNewUuid: string | undefined
      let rows: ProjectPlanNewRow[] = []
      selectedNodes.forEach((p, i) => {
        const uuidMap = {}
        const copied = copiedRows.map(v => {
          const duplicated = duplicate(v)
          uuidMap[duplicated.uuid] = v.uuid
          uuidMap[v.uuid] = duplicated.uuid
          return duplicated
        })
        const newRows = copied.map(c => {
          const oldUuid = uuidMap[c.uuid]
          const oldTreeValue = treeMap[oldUuid]
          c.treeValue = [
            ...p.data.treeValue,
            ...oldTreeValue.map(otv => uuidMap[otv]),
          ]
          return c
        })
        if (i === 0) {
          firstNewUuid = copied[0].uuid
        }
        result = addRowsToLastChild(result, newRows, p.data.uuid)
        rows = rows.concat(newRows)
      })
      setData(result)
      setTimeout(() => {
        // Timeout to update cumulations of pasted parent rows
        addCumulationToAncestors(rows)
      }, 500)
      setTimeout(() => selectedNodes.forEach(n => n.setExpanded(true)), 300)
      firstNewUuid && focusRow(gridApiRef.current, firstNewUuid)
    },
    []
  )

  const pasteRowsNameOnly = useCallback(
    () =>
      pasteRows((row: ProjectPlanNewRow) =>
        duplicateProjectPlanNewRowNameOnly(row, generateCode)
      ),
    [generateCode, pasteRows]
  )

  const pasteSelectedRows = useCallback(
    (selectedItem: MultiSelectDialogSelection[]) => {
      pasteRows((row: ProjectPlanNewRow) => {
        const wbsItemUuid = generateUuid()
        const wbsItem = {
          uuid: wbsItemUuid,
          code: generateCode(),
          type: row.body?.wbsItem?.wbsItemType?.rootType!,
          wbsItemType: row.body?.wbsItem?.wbsItemType!,
          ticketListUuid: row.body?.wbsItem?.ticketListUuid,
          status: WbsItemStatus.TODO,
          scheduledDate: { startDate: undefined, endDate: undefined },
          actualDate: { startDate: undefined, endDate: undefined },
        } as Partial<NewWbsItemRow>
        selectedItem.forEach(selected => {
          const path = `body.wbsItem.${selected.value}`
          const value = objects.getValue(row, path)
          objects.setValue(wbsItem, selected.value, value)
        })
        return {
          ...row,
          uuid: generateUuid(),
          wbsItemUuid: wbsItemUuid,
          treeValue: [],
          body: {
            wbsItem,
            cumulation: new ProjectPlanCumulation(),
          },
        } as ProjectPlanNewRow
      })
    },
    [generateCode, pasteRows]
  )

  const moveCutRow = useCallback(() => {
    const copied = contextRef.current.copied
    const selectedNodes = gridApiRef.current
      ? getSelectedNode(gridApiRef.current)
      : undefined
    if (
      !gridApiRef.current ||
      !selectedNodes ||
      !copied?.every(v => !!v.cut) ||
      !validatePaste(selectedNodes)
    ) {
      return
    }
    const overNode = selectedNodes[0]
    const movedData = copied
      .map(v => prevData.current.find(d => d.uuid === v.id))
      .filter(v => !!v)
    const fromNodes = movedData
      .map(v => gridApiRef.current!.getRowNode(v.uuid))
      .filter(v => v)
    if (!overNode || _.isEmpty(movedData)) return
    setData(moveRowsToLastChild(prevData.current, movedData, overNode.id))
    overNode.setExpanded(true)
    focusRow(gridApiRef.current, movedData[0].uuid)

    // Refresh ancestor cumulations
    const ids = fromNodes.map(v => v.id)
    const topLevelNodes = fromNodes.filter(n => !ids.includes(n.parent?.id))
    const ancestors = {}
    // Subtract cumulations
    topLevelNodes.forEach(fromNode => {
      ReportReCalculator.delete(
        fromNode.data,
        getAncestorNodes(fromNode.parent ?? undefined).map(
          a => ancestors[a.id!] ?? a.data
        )
      ).forEach(subtracted => {
        ancestors[subtracted.uuid] = subtracted
      })
    })
    // Add cumulations
    const overAncestorNodes = getAncestorNodes(overNode)
    topLevelNodes.forEach(toNode => {
      ReportReCalculator.add(
        toNode.data,
        overAncestorNodes.map(a => ancestors[a.id!] ?? a.data)
      ).forEach(added => {
        ancestors[added.uuid] = added
      })
    })
    // Refresh cumulation
    for (const key in ancestors) {
      const node = gridApiRef.current?.getRowNode(key)
      node?.setData(ancestors[key])
    }
  }, [])

  const contextMenu = useCallback(
    (params: GetContextMenuItemsParams) => {
      if (!params.node) return []
      const selectedNodes = getSelectedNode(params.api)
      const selectedWbsItems: NewWbsItemRow[] = selectedNodes.map(
        v => v.data.body?.wbsItem
      )
      const canCopy = validateCopy(selectedNodes)
      const canPaste = validatePaste(selectedNodes)
      const canCopyPaste = canPaste && params.context.copied.every(v => !v.cut)
      const canCutPaste = canPaste && params.context.copied.every(v => !!v.cut)
      const canCopyAll =
        !params.node.data.body?.wbsItem?.wbsItemType.isWorkgroup() &&
        selectedNodes.length === 1
      const addCallback = (d, r) => {
        setData(d)
        addCumulationToAncestors(r)
      }
      const items = [
        ...(selectedNodes.length === 1
          ? [
              // When single node is selected
              ...switchRootWbsMenuItems(params),
            ]
          : []),
        addCopyURLMenuItems(selectedWbsItems),
        addCopyURLAndNameMenuItems(selectedWbsItems),
        'separator',
        ...(selectedNodes.length === 1
          ? [
              ...addRowAboveMenuItems(params, data, addCallback, generateCode),
              ...addRowToChildMenuItems(
                params,
                data,
                addCallback,
                generateCode
              ),
              ...addRowsToChildMenuItems(params, data, {
                onAddRows: (type, parentUuid) =>
                  dialog.openWbsItem({ type, parentUuid }),
              }),
            ]
          : []),
        ...duplicateSameNameTaskMenuItems(
          params,
          data,
          addCallback,
          generateCode
        ),
        ...(rootProjectPlanUuid
          ? []
          : [
              ...addWorkgroupMenuItems(params, data, { setData }, generateCode),
              ...(selectedNodes.length === 1
                ? [
                    ...changeProcessToWorkgroupMenuItems(params, data, {
                      setData: (
                        data: ProjectPlanNewRow[],
                        moved: ProjectPlanNewRow[]
                      ) => {
                        setData(data)

                        if (!gridApiRef.current) return
                        const movedNodes = moved
                          .map(v => gridApiRef.current!.getRowNode(v.uuid))
                          .filter(v => v) as IRowNode[]
                        // Refresh ancestor cumulations
                        const ancestors = {}
                        // Subtract cumulations
                        if (params.node) {
                          ReportReCalculator.delete(
                            params.node.data,
                            getAncestorNodes(
                              params.node.parent ?? undefined
                            ).map(a => ancestors[a.id!] ?? a.data)
                          ).forEach(subtracted => {
                            ancestors[subtracted.uuid] = subtracted
                          })
                        }
                        // Refresh cumulation
                        for (const key in ancestors) {
                          const node = gridApiRef.current?.getRowNode(key)
                          node?.setData(ancestors[key])
                        }
                        // Refresh type cells
                        setTimeout(() => {
                          const rowNodes = moved
                            .map(d => gridApiRef.current?.getRowNode(d.uuid))
                            .filter((n): n is IRowNode => !!n)
                          if (rowNodes.length > 0) {
                            gridApiRef.current?.refreshCells({
                              rowNodes,
                              force: true,
                            })
                          }
                        }, 0)
                      },
                    }),
                  ]
                : []),
            ]),
        ...(selectedNodes.length === 1
          ? [
              ...addTicketMenuItems(
                params,
                data,
                {
                  setData: addCallback,
                  onAddTicket: addTicket,
                  onAddTickets: parentUuid => dialog.openTicket({ parentUuid }),
                },
                generateCode
              ),
            ]
          : []),
        'separator',
        ...deleteRowMenuItems(params, selectedNodes, data, () => removeRow()),
        // Copy
        canCopy && copyTreeMenuItems(params, data),
        // Copy all
        canCopyAll &&
          copyAllTreeMenuItems(params, data, {
            afterCopy: uuids => enqueue(uuids),
          }),
        // Paste
        canCopyPaste &&
          pasteTreeMenuItems(params, {
            pasteNameOnly: () => pasteRowsNameOnly(),
            selectColumns: () => dialog.openColumnSelect(),
          }),
        // Cut
        canCopy && cutTreeMenuItems(params, data),
        canCutPaste &&
          pasteCutTreeMenuItems(params, data, {
            duplicateRow: row => duplicateProjectPlanNewRow(row, generateCode),
            setData: (
              data: ProjectPlanNewRow[],
              moved: ProjectPlanNewRow[]
            ) => {
              setData(data)

              if (!gridApiRef.current) return
              const movedNodes = moved
                .map(v => gridApiRef.current!.getRowNode(v.uuid))
                .filter(v => v) as IRowNode[]
              // Refresh ancestor cumulations
              const ancestors = {}
              // Subtract cumulations
              movedNodes.forEach(fromNode => {
                ReportReCalculator.delete(
                  fromNode.data,
                  getAncestorNodes(fromNode.parent ?? undefined).map(
                    a => ancestors[a.id!] ?? a.data
                  )
                ).forEach(subtracted => {
                  ancestors[subtracted.uuid] = subtracted
                })
              })
              // Add cumulations
              const overAncestorNodes = getAncestorNodes(
                params.node ?? undefined
              )
              movedNodes.forEach(toNode => {
                ReportReCalculator.add(
                  toNode.data,
                  overAncestorNodes.map(a => ancestors[a.id!] ?? a.data)
                ).forEach(added => {
                  ancestors[added.uuid] = added
                })
              })
              // Refresh cumulation
              for (const key in ancestors) {
                const node = gridApiRef.current?.getRowNode(key)
                node?.setData(ancestors[key])
              }
            },
          }),
        ...groupRowMenuItems(params),
        ...reportMenuItems(params, data, { setData }),
      ].filter(v => !!v) as (DefaultMenuItem | MenuItemDef)[]
      actionPopper.close()
      return items.filter(
        (item: DefaultMenuItem | MenuItemDef, index: number) =>
          item !== 'separator' ||
          (0 < index && items[index - 1] !== 'separator')
      )
    },
    [data, rootProjectPlanUuid, edited, actionPopper]
  )

  const dragTreeStyle = useDragTreeStyle(
    ref,
    acceptChild,
    gridApiRef.current,
    updateContext
  )

  useEffect(() => {
    // For tag filter option
    updateContext({ tags })
  }, [tags, updateContext])

  const prevMilestonesJson = useRef<string | undefined>(undefined)
  useEffect(() => {
    updateContext({ milestones })
    const currentJson = JSON.stringify(milestones ?? [])
    const prevJson = prevMilestonesJson.current
    if (prevJson !== undefined && prevJson !== currentJson) {
      const api = gridApiRef.current
      if (api && api.getColumnDef('ganttChart')) {
        api.refreshCells({ columns: ['ganttChart'], force: true })
        api.refreshHeader()
      }
    }
    prevMilestonesJson.current = currentJson
  }, [milestones, updateContext])

  const handleRegisterMilestoneCallbacks = useCallback(
    (callbacks: {
      openWithDate: (date: string) => void
      openWithUuid: (uuid: string) => void
    }) => {
      updateContext({
        isMilestoneEnabled,
        onOpenMilestoneDialogWithDate: callbacks.openWithDate,
        onOpenMilestoneDialogWithUuid: callbacks.openWithUuid,
      })
    },
    [isMilestoneEnabled, updateContext]
  )

  const ganttParameterVersionRef = useRef(0)
  const onGanttParameterChangedRef = useRef<() => void>()
  useEffect(() => {
    const version = ++ganttParameterVersionRef.current
    const run = async () => {
      const api = gridApiRef.current
      if (!api) return
      const [ganttDisplayTimeScale, ganttTimeScale] =
        await generateGanttScale(ganttParameter)
      if (ganttParameterVersionRef.current !== version) return
      updateContext({
        ganttParameter: ganttParameter,
        ganttDisplayTimeScale,
        ganttTimeScale,
        progressLineEnabled:
          isGanttV2 &&
          ganttParameter.displayOptions.showProgressLine &&
          (api.getColumn('ganttChart')?.isVisible() ?? false),
      })
      api.setColumnWidths([
        { key: 'ganttChart', newWidth: getGanttChartWidth(ganttParameter) },
      ])
      api.redrawRows()
      api.refreshHeader()
      api.ensureColumnVisible(
        'ganttChart',
        ganttParameter.calcNearestPosition()
      )
    }
    onGanttParameterChangedRef.current = run
    if (isGridReady && pageState.initialized && bulkSheetState.initialized) {
      run()
    }
  }, [
    isGridReady,
    ganttParameter,
    pageState.initialized,
    bulkSheetState.initialized,
    updateContext,
  ])

  const restoreExpandedRows = useCallback(
    (api?: GridApi) => {
      const gridApi = api ?? gridApiRef.current
      if (!bulkSheetState.expandedRowIds || !gridApi) return
      setTimeout(() => {
        const removed: string[] = []
        gridApi.forEachNode(node => {
          if (node.id && bulkSheetState.expandedRowIds.includes(node.id)) {
            if (node.childrenAfterGroup && node.childrenAfterGroup.length > 0) {
              node.setExpanded(true)
            } else {
              removed.push(node.id)
            }
          }
        })
        removed.length > 0 && bulkSheetState.collapseRows(removed)
      }, 100)
    },
    [bulkSheetState]
  )

  const rememberColumnState = useCallback(() => {
    const columnState = gridApiRef.current?.getColumnState()
    const autoColumnState = columnState?.find(
      c => c.colId === 'ag-Grid-AutoColumn'
    )
    if (autoColumnState && gridOptions.autoGroupColumnDef) {
      gridOptions.autoGroupColumnDef.width = autoColumnState?.width ?? undefined
    }
    columnState && bulkSheetState.saveColumnState(columnState)
  }, [bulkSheetState, gridOptions.autoGroupColumnDef])

  const onGridReady = useCallback(
    (event: GridReadyEvent) => {
      gridApiRef.current = event.api
      setIsGridReady(true)
      if (!_.isEmpty(bulkSheetState.columnState)) {
        event.api.applyColumnState({
          state: bulkSheetState.columnState,
          applyOrder: true,
        })
      }
      gridOptionsRef.current = gridOptions
      if (pageState.initialized && bulkSheetState.initialized) {
        onGanttParameterChangedRef.current?.()
      }
    },
    [bulkSheetState, gridOptions, pageState.initialized]
  )

  // Restore row state.
  const onFirstDataRendered = useCallback(
    (e: FirstDataRenderedEvent) => {
      restoreExpandedRows(e.api)
      const columnState = e.api.getColumnState()
      if (!columnState?.find(v => v.colId === 'ganttChart')?.hide) {
        showGantt(true)
        if (featureFlagService.isEnabled('gantt-v2')) {
          updateContext({ isRowHeightFixed: true })
          e.api.refreshCells({
            force: true,
            columns: ['drag', 'rowNumber'],
          })
        }
      }
      if (!_.isEmpty(bulkSheetState.filterState)) {
        e.api.setFilterModel(bulkSheetState.filterState ?? null)
      }
      bulkSheetState.finishRestoring()
      setLoading(false)
      // Register grid API for dependency/critical path hooks
      dependencyData.setGridApi(e.api)
      criticalPathData.setGridApi(e.api)
    },
    [bulkSheetState, restoreExpandedRows, updateContext]
  )

  const rowHeightBeforeGantt = useRef<number | null>(null)
  const GANTT_MIN_ROW_HEIGHT = 49
  const adjustRowHeightForGantt = useCallback(
    (isDisplayGantt: boolean) => {
      if (!featureFlagService.isEnabled('gantt-v2')) return
      if (isDisplayGantt) {
        if (pageState.rowHeight !== GANTT_MIN_ROW_HEIGHT) {
          rowHeightBeforeGantt.current = pageState.rowHeight
          pageState.setRowHeight(GANTT_MIN_ROW_HEIGHT)
        }
        updateContext({ isRowHeightFixed: true })
        gridApiRef.current?.refreshCells({
          force: true,
          columns: ['drag', 'rowNumber'],
        })
      } else {
        if (rowHeightBeforeGantt.current !== null) {
          pageState.setRowHeight(rowHeightBeforeGantt.current)
          rowHeightBeforeGantt.current = null
        }
        updateContext({ isRowHeightFixed: false })
        gridApiRef.current?.refreshCells({
          force: true,
          columns: ['drag', 'rowNumber'],
        })
      }
    },
    [pageState.rowHeight, dialog, updateContext]
  )

  // Fetch dependency/critical path data once after initial body data load.
  // Only fires on the first isFetchingBody true→false transition.
  // Subsequent transitions (e.g. expanding rows) must not re-fetch,
  // as that would overwrite unsaved link edits with server data.
  // Reload is handled separately in refreshAll's setTimeout.
  const prevIsFetchingBody = usePrevious(isFetchingBody)
  const depCpInitialFetchDone = useRef(false)
  // Ref-based callback so onDisplayedRowUpdated can also trigger this
  // without adding dependencies to its useMemo.
  const triggerDepCpInitialFetchRef = useRef<(api: GridApi) => void>()
  triggerDepCpInitialFetchRef.current = (api: GridApi) => {
    if (depCpInitialFetchDone.current) return
    depCpInitialFetchDone.current = true
    const uuidToRowIndex = buildUuidToRowIndexMap(api)
    dependencyData.fetchDependencies(uuidToRowIndex)
    criticalPathData.fetchCriticalPaths(uuidToRowIndex)
  }
  useEffect(() => {
    const api = gridApiRef.current
    if (
      prevIsFetchingBody &&
      !isFetchingBody &&
      api &&
      !depCpInitialFetchDone.current
    ) {
      triggerDepCpInitialFetchRef.current?.(api)
    }
  }, [isFetchingBody, prevIsFetchingBody])

  const onColumnVisible = useCallback(
    (e: ColumnVisibleEvent) => {
      if (e.column?.getColDef().field === 'ganttChart') {
        const isVisible = !!e.visible
        showGantt(isVisible)
        adjustRowHeightForGantt(isVisible)
        if (isVisible) {
          gridApiRef.current?.ensureColumnVisible(
            'ganttChart',
            ganttParameter.calcNearestPosition()
          )
        }
      } else {
        const ganttChart = (e.columns ?? []).find(
          v => v.getColDef().field === 'ganttChart'
        )
        if (ganttChart) {
          const isVisible = ganttChart.isVisible()
          showGantt(isVisible)
          adjustRowHeightForGantt(isVisible)
        }
      }
      rememberColumnState()
      onSortedColumnsStateChanged(e)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps -- adjustRowHeightForGanttはガント表示切替時に必要
    [rememberColumnState, adjustRowHeightForGantt]
  )

  const onFilterChanged = useCallback(
    (e: FilterChangedEvent) => {
      const filterModel = e.api.getFilterModel()
      delete filterModel['uuid']
      bulkSheetState.saveFilterState(filterModel)
      setFilteredColumns(
        Object.keys(filterModel)
          .map(col => e.api.getColumnDef(col))
          .filter(v => !!v && v.field !== 'uuid') as ColDef[]
      )
    },
    [bulkSheetState]
  )

  const onSortedColumnsStateChanged = useCallback(
    (e: { api: GridApi }) => {
      const sortedColumns = e.api
        .getColumnState()
        .filter(col => !!col.sort)
        .map(col => {
          return {
            ...e.api.getColumnDef(col.colId),
            colId: col.colId,
          }
        })
        .filter(v => !!v) as ColDef[]
      e.api.setGridOption('suppressRowDrag', 0 < sortedColumns.length)

      const columnState = gridApiRef.current?.getColumnState()
      const sortedColumnState: { [colId: string]: ColumnState } = {}
      columnState &&
        columnState.forEach(state => {
          if (state.sort) {
            sortedColumnState[state.colId] = state
          }
        })
      const sortedColumnsState: SortedColumnState[] = sortedColumns.map(col => {
        return {
          colId: col.colId,
          field: col.field,
          headerName: col.headerName,
          sort: col.colId ? sortedColumnState[col.colId]?.sort : null,
        }
      })

      setSortColumnsState(sortedColumnsState)
    },
    [bulkSheetState]
  )

  const onSortChanged = useCallback(
    (e: SortChangedEvent) => {
      rememberColumnState()
      onSortedColumnsStateChanged(e)
    },
    [bulkSheetState]
  )

  const onDeleteFilteredColumn = useCallback((column: ColDef) => {
    if (!column || !gridApiRef.current) return
    const filterModel = gridApiRef.current.getFilterModel()
    delete filterModel[column.colId || column.field || '']
    gridApiRef.current.setFilterModel(filterModel)
  }, [])

  const resetFilters = useCallback(() => {
    if (!gridApiRef.current) return
    // カラムフィルターを全クリア。クイックフィルター（外部フィルター）は別管理のため、
    // setFilterModel(null) では消えないので個別にリセットする
    gridApiRef.current.setFilterModel(null)
    if (!quickFilters) {
      quickFilterUuidsRef.current = undefined
    } else {
      filterByQuickFilters(quickFilters, true)
    }
  }, [quickFilters, filterByQuickFilters])

  const onDeleteSortedColumn = useCallback((colId: string | ColDef<any>) => {
    gridApiRef.current?.applyColumnState({
      state: [{ colId: colId.toString(), sort: null }],
    })
  }, [])

  const onDeleteSortedAllColumns = useCallback(() => {
    gridApiRef.current?.applyColumnState({
      defaultState: { sort: null },
    })
  }, [])

  const onChangeSortColumnState = useCallback(
    (colId: string | ColDef<any>, sort: 'asc' | 'desc' | null) => {
      gridApiRef.current?.applyColumnState({
        state: [{ colId: colId.toString(), sort }],
      })
    },
    []
  )

  const limitChangeLength = 100
  const hasTooManyChange =
    limitChangeLength !== undefined
      ? (changeLength ?? 0) > limitChangeLength
      : false

  const calculateChangeLength = useCallback(() => {
    let addedLength = 0
    let editedLength = 0

    for (const row of data) {
      if (row.added) {
        addedLength++
      } else if (row.edited) {
        editedLength++
      }
    }

    setChangeLength(editedLength + addedLength + deletedRows.length)
  }, [data, deletedRows])

  const onCellValueChanged = useCallback(() => {
    calculateChangeLength()
    actionPopper.close()
  }, [calculateChangeLength])

  const onRowDataUpdated = useCallback(
    (e: RowDataUpdatedEvent<ProjectPlanNewRow>) => {
      calculateChangeLength()
      e.api?.refreshCells({
        columns: [
          'rowNumber',
          FIELD_WBSITEM_ACTUALDATE_START,
          FIELD_WBSITEM_ACTUALDATE_END,
          FIELD_WBSITEM_ACTUALHOUR,
        ],
        force: true,
      })
    },
    [calculateChangeLength]
  )

  const resetCopiedRows = useCallback(() => {
    if (!gridApiRef.current) return
    const currentCopiedNodes =
      contextRef.current.copied?.map(v =>
        gridApiRef.current!.getRowNode(v.id)
      ) ?? []
    updateContext({ copied: [] })
    currentCopiedNodes.length &&
      gridApiRef.current.redrawRows({ rowNodes: currentCopiedNodes })
  }, [updateContext])

  const validateBeforeSubmit = useCallback(
    (rows: ProjectPlanNewRow[]) => {
      // Rows that are added but not edited will not be registered.　So ignore them.
      const targetRowUuids = rows.filter(row => row.edited).map(row => row.uuid)
      const errors = validateNodes({
        gridApi: gridApiRef.current,
        uuids: targetRowUuids,
      })
      updateContext({ errors })
    },
    [updateContext]
  )

  const onSubmit = useCallback(async () => {
    setLoading(true)
    try {
      gridApiRef.current?.stopEditing()
      validateBeforeSubmit(data)
      if (contextRef.current.errors.hasMessage()) {
        store.dispatch(
          addGlobalMessage({
            type: MessageLevel.WARN,
            title: intl.formatMessage({ id: 'global.warning.businessError' }),
            text: contextRef.current.errors.toMessage(id => {
              const node = gridApiRef.current?.getRowNode(id)
              return !!node ? getRowNumber(node).toString() : ''
            }),
          })
        )
        return
      }

      bulkSheetState.saveImmediately()

      // Save
      const [response, sprintProductResponse, sprintBacklogResponse] =
        submit.current ? await submit.current() : await save()

      if (response.hasWarning) {
        const messages = extractValuesFromResponse(response.json, 'messages')
        handleWarning(messages, uuid => {
          const target = data.find(v => v.body?.wbsItem.uuid === uuid)
          return target?.body?.wbsItem.displayName
        })
      }
      if (
        !response.hasError &&
        !response.hasWarning &&
        !sprintProductResponse.hasError &&
        !sprintBacklogResponse.hasError
      ) {
        // Save dependency/critical path data after WBS items are saved
        await dependencyData.saveDependencies()
        await criticalPathData.saveCriticalPaths()

        runAsyncWithPerfMonitoring('refreshAll after onSubmit', async () => {
          store.dispatch(
            addScreenMessage(functionUuid, {
              type: MessageLevel.SUCCESS,
              title: intl.formatMessage({ id: 'registration.complete' }),
            })
          )
          await refreshAll()
        })
      }
    } finally {
      runWithPerfMonitoring('resetCopiedRows after onSubmit', () => {
        resetCopiedRows()
      })
      setLoading(false)
    }
  }, [data, save, bulkSheetState, validateBeforeSubmit])

  const onReload = useCallback(() => {
    if (hasChanged()) {
      dialog.openCancel()
    } else {
      refreshAll()
    }
  }, [data, bulkSheetState.expandedRowIds, treeChangedCount])

  const refreshAll = useCallback(
    async (forceRefreshTree?: boolean) => {
      if (!gridApiRef.current) return
      setLoading(true)
      try {
        const fetchBodyUuid = !forceRefreshTree
          ? getDisplayedRow(gridApiRef.current).map(node => node.data.uuid)
          : undefined
        const refreshRows = reload.current ?? refresh
        await refreshRows(rootProjectPlanUuid, fetchBodyUuid, {
          forceRefreshTree: forceRefreshTree || treeChangedCount.current > 1500,
        })
      } finally {
        resetCopiedRows()
        updateContext({
          onTree: false,
          draggableNodeId: undefined,
          errors: new InputError(),
        })
        setTimeout(() => {
          const api = gridApiRef.current
          if (!api) return
          api.refreshCells({
            columns: ['body.wbsItem.status', 'ganttChart'],
            force: true,
          })
          // Re-fetch dependency/critical path data from server
          // after grid data is refreshed (isFetchingBody transition may not
          // occur when skeleton response includes body data)
          const uuidToRowIndex = buildUuidToRowIndexMap(api)
          dependencyData.fetchDependencies(uuidToRowIndex)
          criticalPathData.fetchCriticalPaths(uuidToRowIndex)
        }, 500)
        setLoading(false)
        treeChangedCount.current = 0
      }
    },
    [
      rootProjectPlanUuid,
      bulkSheetState.expandedRowIds,
      treeChangedCount,
      updateContext,
      resetCopiedRows,
    ]
  )

  const isFirstRender = useRef(true)
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false
      return
    }
    refreshAll(true)
  }, [rootProjectPlanUuid])
  const prevRestoredAt = usePrevious(bulkSheetState.restoredAt)
  useEffect(() => {
    if (
      prevRestoredAt &&
      bulkSheetState.restoredAt &&
      prevRestoredAt < bulkSheetState.restoredAt
    ) {
      setTimeout(() => {
        // setTimeout is to wait for rows are rendered.
        restoreExpandedRows()
      }, 300)
    }
  }, [restoreExpandedRows, prevRestoredAt, bulkSheetState.restoredAt])

  const onExportExcel = useCallback(
    colIds => {
      const uuids = data.filter(v => !v.body).map(v => v.uuid)
      setLoading(true)
      setOutputExcel(true)
      setExportColIds(colIds)
      enqueue(uuids)
    },
    [data, enqueue]
  )
  useEffect(() => {
    if (outputExcel && !data.some(v => !v.body)) {
      setOutputExcel(false)
      exportExcel({
        fileNamePrefix: 'project_plan',
        gridApi: gridApiRef.current!,
        exportColIds,
        shouldRowBeSkipped: params =>
          !params.node.data.body || !params.node.displayed,
      })
      setLoading(false)
    }
  }, [data, exportColIds, outputExcel])

  const onImportExcel = useExcelImport(
    projectUuid,
    gridOptions,
    contextRef,
    data,
    wbsItemAdditionalProperties,
    setLoading,
    generateCode,
    setData,
    fetchBodyByCode,
    isFetchingBody,
    treeRootUuid
  )

  const getNotPinnedColumns = () => {
    if (!gridApiRef.current) return []
    const allColumnStates = gridApiRef.current.getColumnState()
    const notPinnedColumns = allColumnStates
      .filter(cs => !cs.pinned && !cs.hide)
      .map(cs => cs.colId)
    return notPinnedColumns
  }

  const onSwitchingGanttChartDisplay = useCallback(
    (isDisplayGantt: boolean) => {
      if (!gridApiRef.current) return
      if (isDisplayGantt) {
        gridApiRef.current.applyColumnState({
          state: [{ colId: 'ganttChart', hide: false }],
        })
        updateContext({
          progressLineEnabled:
            isGanttV2 && ganttParameter.displayOptions.showProgressLine,
        })
        gridApiRef.current?.ensureColumnVisible('ganttChart')
        adjustRowHeightForGantt(true)
      } else {
        gridApiRef.current.applyColumnState({
          state: [{ colId: 'ganttChart', hide: true }],
        })
        updateContext({ progressLineEnabled: false })
        gridApiRef.current?.ensureColumnVisible(getNotPinnedColumns()[0])
        adjustRowHeightForGantt(false)
      }
      showGantt(isDisplayGantt)
    },
    [
      adjustRowHeightForGantt,
      updateContext,
      isGanttV2,
      ganttParameter.displayOptions.showProgressLine,
    ]
  )

  const onChangeColumnFilter = useCallback(
    (value: ColumnQuickFilterKey) => {
      if (value === ColumnQuickFilterKey.INITIAL) {
        pageState.setSelectedColumnQuickFilterKey(
          SelectedColumnQuickFilterKey.NONE
        )
        gridApiRef.current?.resetColumnState()
        gridApiRef.current?.setFilterModel(null)
        gridApiRef.current?.setColumnWidths([
          { key: 'ganttChart', newWidth: getGanttChartWidth(ganttParameter) },
        ])
      } else if (value === ColumnQuickFilterKey.RESTORE) {
        pageState.setSelectedColumnQuickFilterKey(
          SelectedColumnQuickFilterKey.NONE
        )
        dialog.openUiState()
      } else {
        pageState.setSelectedColumnQuickFilterKey(
          value.toString() as SelectedColumnQuickFilterKeyType
        )
        let pinned: string[] = []
        let notPinned: string[] = []
        if (value === ColumnQuickFilterKey.PLANNING) {
          pinned = [
            'drag',
            'rowNumber',
            'body.wbsItem.status',
            'action',
            'ag-Grid-AutoColumn',
            'body.wbsItem.team',
            'body.wbsItem.accountable',
            'body.wbsItem.responsible',
            'body.wbsItem.scheduledDate.startDate',
            'body.wbsItem.scheduledDate.endDate',
          ]
          notPinned = [
            'body.wbsItem.estimatedHour.deliverable',
            'body.wbsItem.estimatedHour',
            'ganttChart',
          ]
        } else if (value === ColumnQuickFilterKey.WORK_RESULT) {
          pinned = [
            'drag',
            'rowNumber',
            'body.wbsItem.status',
            'action',
            'ag-Grid-AutoColumn',
            'body.wbsItem.team',
            'body.wbsItem.accountable',
            'body.wbsItem.responsible',
            'body.wbsItem.scheduledDate.startDate',
            'body.wbsItem.scheduledDate.endDate',
            'body.wbsItem.actualDate.startDate',
            'body.wbsItem.actualDate.endDate',
          ]
          notPinned = [
            'body.wbsItem.estimatedHour.deliverable',
            'body.wbsItem.estimatedHour',
            'body.wbsItem.actualHour',
            'ganttChart',
          ]
        } else if (value === ColumnQuickFilterKey.PROGRESS) {
          pinned = [
            'drag',
            'rowNumber',
            'body.wbsItem.status',
            'action',
            'ag-Grid-AutoColumn',
            'body.wbsItem.team',
            'body.wbsItem.accountable',
            'body.wbsItem.responsible',
            'progress.scheduledProgressRate',
            'progress.progressRate',
          ]
          notPinned = [
            'progress.total',
            'progress.scheduledToBe',
            'progress.completed',
            'progress.preceding',
            'progress.delayed',
            'progress.remaining',
            'ganttChart',
          ]
        } else if (value === ColumnQuickFilterKey.PRODUCTIVITY) {
          pinned = [
            'drag',
            'rowNumber',
            'body.wbsItem.status',
            'action',
            'ag-Grid-AutoColumn',
            'body.wbsItem.team',
            'body.wbsItem.accountable',
            'body.wbsItem.responsible',
          ]
          notPinned = [
            'body.wbsItem.estimatedHour.deliverable',
            'body.wbsItem.estimatedHour',
            'body.wbsItem.actualHour',
            'progress.completed',
            'evm.costPerformanceIndex',
            'evm.schedulePerformanceIndex',
            'evm.estimateToComplete',
            'evm.estimateAtCompletion',
            'ganttChart',
          ]
        }
        const visibleColumnIds = [...pinned, ...notPinned]
        if (!gridApiRef.current) return
        const allColumnStates = gridApiRef.current.getColumnState()
        const visibleColumnStates = allColumnStates
          .filter(cs => visibleColumnIds.includes(cs.colId))
          .sort(
            (a, b) =>
              visibleColumnIds.findIndex(id => id === a.colId) -
              visibleColumnIds.findIndex(id => id === b.colId)
          )
          .map(cs => ({
            ...cs,
            pinned: pinned.includes(cs.colId),
            hide: false,
            width:
              cs.colId === 'ganttChart'
                ? getGanttChartWidth(ganttParameter)
                : cs.width,
          }))

        const hiddenColumnStates = allColumnStates
          .filter(cs => !visibleColumnIds.includes(cs.colId))
          .map(cs => ({ ...cs, hide: true }))

        gridApiRef.current.applyColumnState({
          state: [...visibleColumnStates, ...hiddenColumnStates],
          applyOrder: true,
        })
        gridApiRef.current?.ensureColumnVisible(notPinned[0])
      }
    },
    [ganttParameter, pageState.selectedColumnQuickFilterKey]
  )

  const handleOptimizeGanttColumnWidth = useCallback(() => {
    const api = gridApiRef.current
    if (!api) return
    const viewportEl = document.querySelector<HTMLElement>(
      '.ag-center-cols-viewport'
    )
    if (!viewportEl) return
    const otherColumnsWidth = api
      .getDisplayedCenterColumns()
      .filter(c => c.getColId() !== 'ganttChart')
      .reduce((sum, c) => sum + c.getActualWidth(), 0)
    const availableGanttWidth = viewportEl.clientWidth - otherColumnsWidth
    if (availableGanttWidth <= 0) return
    const contentWidth = getGanttChartWidth(ganttParameter)
    const minWidth =
      contentWidth * GANTT_FIT_MIN_CONTENT_RATIO[ganttParameter.unit]
    const newWidth = Math.max(availableGanttWidth, minWidth)
    api.setColumnWidths([{ key: 'ganttChart', newWidth }])
  }, [ganttParameter])

  const focusNextOrPrevRow = useCallback(
    (
      gridApi: GridApi,
      data: ProjectPlanNewRow[],
      lastSelectedIndex: number,
      targetUuids: string[]
    ) => {
      for (let i = lastSelectedIndex + 1; i < data.length; i++) {
        if (!targetUuids.includes(data[i].uuid)) {
          focusRow(gridApi, data[i].uuid)
          return
        }
      }
      for (let i = lastSelectedIndex - 1; i >= 0; i--) {
        if (!targetUuids.includes(data[i].uuid)) {
          focusRow(gridApi, data[i].uuid)
          return
        }
      }
    },
    []
  )

  const onDeleteRows = useCallback(() => {
    const allChildren = getAllLeafChildren(deleteTargetNodesRef.current).map(
      v => v.data
    ) as ProjectPlanNewRow[]
    const target = _.uniqBy(allChildren, 'uuid')
    const newData = removeRows(data, target)
    setData(newData)
    deleteCumulationFromAncestors(target)
    deleteRows(target)
    dialog.closeDeleteConfirmation()

    const deletedWbsItemUuids = new Set<string>(
      target.map(row => row.wbsItemUuid)
    )
    dependencyData.removeByWbsItemUuids(deletedWbsItemUuids)
    criticalPathData.removeByWbsItemUuids(deletedWbsItemUuids)

    const lastSelectedRow = allChildren.at(-1)
    const lastSelectedIndex = data.findIndex(
      d => d.uuid === lastSelectedRow?.uuid
    )
    const targetUuids = target.map(row => row.uuid)
    if (!gridApiRef.current) return
    focusNextOrPrevRow(gridApiRef.current, data, lastSelectedIndex, targetUuids)
  }, [
    data,
    dependencyData.removeByWbsItemUuids,
    criticalPathData.removeByWbsItemUuids,
  ])

  // Enqueue on empty rows are displayed.
  // This is necessary to fetch body after reloaded.
  const onDisplayedRowUpdated = useMemo(
    () =>
      _.debounce((api: GridApi) => {
        if (!ref.current) return
        const displayedRows = getDisplayedRow(api)
        const fetchBodyUuid = displayedRows
          .filter(node => !node.data.body)
          .map(node => node.data.uuid)
        enqueue(fetchBodyUuid)
        // When skeleton includes body data (e.g. treeRootUuid specified),
        // fetchBody is never called and isFetchingBody never transitions.
        // Trigger dep/cp fetch as fallback.
        if (fetchBodyUuid.length === 0 && displayedRows.length > 0) {
          triggerDepCpInitialFetchRef.current?.(api)
        }
      }, 500),
    [enqueue]
  )

  const onBodyScrollEnd = useCallback(
    (event: BodyScrollEndEvent) => {
      if (event.direction === 'horizontal') return
      onDisplayedRowUpdated(event.api)
    },
    [onDisplayedRowUpdated]
  )

  const onModelUpdated = useCallback(
    (event: ModelUpdatedEvent) => {
      onDisplayedRowUpdated(event.api)
    },
    [onDisplayedRowUpdated]
  )

  // Enqueue children on row group is opened.
  // Save row state after row group opened or closed.
  const onRowGroupOpened = useCallback(
    (event: RowGroupOpenedEvent) => {
      const key = event.node.key
      if (!key) return
      if (event.expanded) {
        bulkSheetState.expandRows([key])

        // Fetch body
        const children = allDescendants(event.node).filter(
          childNode =>
            childNode.parent?.id === event.node.id && !childNode.data.body
        )
        const displayedRows = getDisplayedRow(event.api)
        const fetchTargetUuid = children
          .filter(childNode =>
            displayedRows.some(row => row.id === childNode.id)
          )
          .map(childNode => childNode.data.uuid)
        enqueue(fetchTargetUuid)
      } else {
        bulkSheetState.collapseRows([key])
      }
    },
    [enqueue, bulkSheetState]
  )

  const getAncestorNodes = useCallback((node?: IRowNode): IRowNode[] => {
    const result: IRowNode[] = []
    let n: IRowNode | undefined = node
    while (n && n.id !== 'ROOT_NODE_ID') {
      result.unshift(n)
      n = n.parent?.key ? n.parent : undefined
    }
    return result
  }, [])

  const changeWorkgroupToProcessOfMovedData = (
    result: ProjectPlanNewRow[],
    movedData: ProjectPlanNewRow[]
  ): string[] => {
    const wbsItemTypes = store.getState().project.wbsItemTypes
    const processType = wbsItemTypes.process
    const workgroupUuids = new Set(
      movedData
        .filter(d => d.body?.wbsItem?.wbsItemType?.isWorkgroup())
        .map(d => d.uuid)
    )
    if (workgroupUuids.size === 0) return []
    const changedUuids: string[] = []
    for (const row of result) {
      if (!workgroupUuids.has(row.uuid) || !row.body) continue
      if (!row.editedData) {
        row.editedData = {}
      }
      row.editedData['body.wbsItem.wbsItemType'] = row.body.wbsItem.wbsItemType
      row.body = {
        ...row.body,
        wbsItem: {
          ...row.body.wbsItem,
          wbsItemType: processType,
          baseWbsItemType: processType,
        },
      }
      changedUuids.push(row.uuid)
      workgroupUuids.delete(row.uuid)
      if (workgroupUuids.size === 0) break
    }
    return changedUuids
  }

  const onRowDragEnd = useCallback(
    (event: RowDragEvent) => {
      const ids = event.nodes.map(v => v.id)
      const topLevelNodes = event.nodes.filter(n => !ids.includes(n.parent?.id))
      const movedData = sortByRowIndex(topLevelNodes).map(node => node.data)
      const overNode = event.overNode

      if (overNode && overNode.id === contextRef.current.draggableNodeId) {
        try {
          if (contextRef.current.onTree) {
            const result = moveRowsToLastChild(data, movedData, overNode.id)
            const changedUuids = changeWorkgroupToProcessOfMovedData(
              result,
              movedData
            )
            const count = _.sum(topLevelNodes.map(v => v.allChildrenCount ?? 0))
            if (count > 1500) {
              treeChangedCount.current = treeChangedCount.current + count
              // Refresh all to avoid slow process
              gridApiRef.current && setData([])
              setData(result)
              const parentNode = gridApiRef.current?.getRowNode(
                overNode.id ?? ''
              )
              parentNode?.setExpanded(true)
              // Restore expanded rows
              restoreExpandedRows()
            } else {
              setData(result)
              overNode.setExpanded(true)
            }
            // Focus new position
            topLevelNodes[0].id && focusRow(event.api, topLevelNodes[0].id)

            // Refresh ancestor cumulations
            const ancestors = {}
            // Subtract cumulations
            topLevelNodes.forEach(fromNode => {
              ReportReCalculator.delete(
                fromNode.data,
                getAncestorNodes(fromNode.parent ?? undefined).map(
                  a => ancestors[a.id!] ?? a.data
                )
              ).forEach(subtracted => {
                ancestors[subtracted.uuid] = subtracted
              })
            })
            // Add cumulations
            const overAncestorNodes = getAncestorNodes(overNode)
            topLevelNodes.forEach(toNode => {
              ReportReCalculator.add(
                toNode.data,
                overAncestorNodes.map(a => ancestors[a.id!] ?? a.data)
              ).forEach(added => {
                ancestors[added.uuid] = added
              })
            })
            // Refresh cumulation
            for (const key in ancestors) {
              const node = event.api.getRowNode(key)
              node?.setData(ancestors[key])
            }

            // Refresh type cells for workgroup→process conversion
            if (changedUuids.length > 0) {
              setTimeout(() => {
                const rowNodes = changedUuids
                  .map(uuid => event.api.getRowNode(uuid))
                  .filter((n): n is IRowNode => !!n)
                if (rowNodes.length > 0) {
                  event.api.refreshCells({ rowNodes, force: true })
                }
              }, 0)
            }

            return
          } else {
            if (!overNode.id) return
            // If moved toward down, move after overNode.
            if (event.overIndex > (event.node.rowIndex || 0)) {
              setData(slideRowsAfter(data, movedData, overNode.id))
              return
            }
            setData(slideRowsBefore(data, movedData, overNode.id))
          }
        } finally {
          // Clear drag cell style
          dragTreeStyle.refreshDragStyle()
        }
      }
    },
    [data]
  )

  const onCellClicked = useCallback(
    (e: CellClickedEvent) => {
      const { field } = e.colDef
      const colId = e.column.getColId()
      if (
        field === 'body.wbsItem.displayName' &&
        !isOpenWbsItemDetail.current
      ) {
        const pointer: PointerEvent = e.event as PointerEvent
        const clickEl = (pointer.currentTarget ?? pointer.target) as HTMLElement
        if (
          !!clickEl.closest('.sevend-ag-cell-project-plan-tree__icon-button')
        ) {
          // Do not display ActionPopper when clicking on an icon in the name column
          // (Prevent action buttons from appearing on single sheet screens)
          return
        }
        const anchor = clickEl.closest('.ag-row') as HTMLElement
        const anchorRect: DOMRect | undefined = anchor?.getBoundingClientRect()
        const target = anchor?.getElementsByClassName(
          'sevend-ag-cell-project-plan-tree__icon-button'
        )
        const targetRect: DOMRect | undefined =
          0 < (target?.length || 0)
            ? target?.item(0)?.getBoundingClientRect()
            : undefined

        const wbsItem: NewWbsItemRow | undefined = (e.data as ProjectPlanNewRow)
          .body?.wbsItem
        const targetRow = prevData.current?.filter(
          row => row.body?.wbsItem?.uuid === wbsItem?.uuid
        )
        const targetRowUuid = _.isEmpty(targetRow)
          ? undefined
          : targetRow[0].uuid

        const ACTIONPOPPER_ICON_LEFT_OFFSET = 24.5

        // Hide addRowAbove because continuous clicks are not possible
        actionPopper.open({
          offsetX: (targetRect?.left ?? 0) - ACTIONPOPPER_ICON_LEFT_OFFSET,
          offsetY: 0,
          anchor,
          targetRowUuid,
          wbsItem,
        })
      }
      if (e.data.added) return
      const getTargetElement = (event: Event | null | undefined) => {
        const eventTarget = event?.target as HTMLElement
        if (!eventTarget) return null
        return eventTarget.closest('.sevend-ag-cell') as HTMLElement
      }

      if (field === 'body.wbsItem.status') {
        const target = getTargetElement(e.event)
        if (!target) return
        if (!e.data.body?.wbsItem) return

        // If using new status column layout, then open popper only when the MoreIcon is clicked.
        if (useNewStatusColumnLayout) {
          const eventTarget = e.event?.target as HTMLElement | null
          if (!eventTarget) return

          const isMoreIconClicked = eventTarget.closest(
            '.sevend-ag-cell-status__status-change-popper-trigger'
          )
          if (!isMoreIconClicked) return
        }

        popper.open(
          target,
          e.data.body.wbsItem,
          generateUpdateWbsItemDeltaRequest(e.data)
        )
      }
      if (field === FIELD_WBSITEM_ACTUALHOUR) {
        if (e.value <= Number.EPSILON) return
        const w = e.data.body?.wbsItem
        if (!w || !w.wbsItemType.isTask()) return
        dialog.openActualResult(w.uuid)
      }
    },
    [
      actionPopper,
      useNewStatusColumnLayout,
      popper,
      generateUpdateWbsItemDeltaRequest,
      dialog,
    ]
  )

  const onCellEditingStarted = useCallback(
    ({ api, context, node }: CellEditingStartedEvent) => {
      if (context.copied?.some(v => v.id === node.id)) {
        api.stopEditing()
        resetCopiedRows()
        focusCellAfterCopy(api)
      }
      actionPopper.close()
    },
    [actionPopper, resetCopiedRows]
  )

  const onCellDoubleClicked = useCallback(() => popper.close(), [popper])

  const onSpaceKeyDown = useCallback(() => {
    const focusedCell = gridApiRef.current?.getFocusedCell()
    const focusedNode = gridApiRef.current?.getDisplayedRowAtIndex(
      focusedCell?.rowIndex ?? -1
    )
    if (
      !focusedCell ||
      !focusedNode ||
      !document.activeElement!.classList.contains('ag-cell')
    ) {
      return
    }
    focusedNode.setExpanded(!focusedNode.expanded)
  }, [])

  const onEscKeyDown = useCallback(() => {
    resetCopiedRows()
    actionPopper.close()
  }, [resetCopiedRows, actionPopper])

  useKeyBind(
    [
      { key: KEY_SAVE, fn: onSubmit, stopDefaultBehavior: true },
      { key: KEY_SPACE, fn: onSpaceKeyDown },
      { key: KEY_ESC, fn: onEscKeyDown },
      { key: 'alt+shift+l', fn: () => addAbove(wbsItemTypes.task) },
      { key: 'alt+shift+k', fn: () => addAbove(wbsItemTypes.deliverable) },
      { key: 'alt+shift+j', fn: () => addAbove(wbsItemTypes.deliverableList) },
      { key: 'alt+shift+h', fn: () => addAbove(wbsItemTypes.process) },
      { key: 'mod+shift+l', fn: () => addToChild(wbsItemTypes.task) },
      { key: 'mod+shift+k', fn: () => addToChild(wbsItemTypes.deliverable) },
      {
        key: 'mod+shift+j',
        fn: () => addToChild(wbsItemTypes.deliverableList),
        stopDefaultBehavior: true,
      },
      { key: 'mod+shift+h', fn: () => addToChild(wbsItemTypes.process) },
      { key: 'alt+shift+d', fn: () => removeRow() },
      { key: 'alt+shift+c', fn: () => copyRow() },
      {
        key: 'alt+shift+x',
        fn: () => copyRow(true),
        stopDefaultBehavior: true,
      },
      { key: 'mod+i', fn: () => pasteRow() },
      {
        key: 'mod+shift+i',
        fn: () => pasteRowsNameOnly(),
        stopDefaultBehavior: true,
      },
      { key: 'mod+shift+v', fn: () => moveCutRow(), stopDefaultBehavior: true },
    ],
    [onSubmit, functionUuid],
    functionUuid
  )

  const getLastSelectTicketListUiStateKey = useCallback(
    (ticketType: string) =>
      `${UiStateKey.LastSelectedTicketListToAddTicket}-${projectUuid}-${ticketType}`,
    [projectUuid]
  )

  const addTicket = useCallback(
    async (parentUuid: string, ticketType: WbsItemTypeVO) => {
      const hasRequiredSaveData: boolean = edited
      if (!ticketType || !ticketType.isTicket()) return
      const parentRow = prevData.current.find(row => row.uuid === parentUuid)
      const parentWbsItem = parentRow?.body?.wbsItem
      const parentType = parentWbsItem?.wbsItemType
      if (
        !parentWbsItem ||
        !parentType ||
        parentType.canBeChildOf(ticketType)
      ) {
        return
      }
      const response = await TicketListAPI.getAll({
        ticketType: ticketType.code,
      })
      const ticketLists: TicketListDetail[] = response?.json
      if (_.isEmpty(ticketLists)) {
        store.dispatch(
          addGlobalMessage({
            type: MessageLevel.WARN,
            title: intl.formatMessage({ id: 'global.warning.businessError' }),
            text: intl.formatMessage(
              {
                id: 'ticket.create.error.ticketlist.not.exists',
              },
              { type: ticketType.name }
            ),
          })
        )
        return
      }
      const added: ProjectPlanNewRow = createNewProjectPlanNewRow(
        ticketType,
        generateCode
      )
      const newData: ProjectPlanNewRow[] = addRowsToLastChild(
        prevData.current,
        [added],
        parentUuid
      )
      setData(newData)
      const newRow: ProjectPlanNewRow = newData.find(
        v => v.uuid === added.uuid
      )!
      addCumulationToAncestors([newRow])

      const getUiStateResponse = await uiStates.get({
        key: getLastSelectTicketListUiStateKey(ticketType.code),
        scope: UiStateScope.User,
      })
      const ticketListUuid = getUiStateResponse?.json?.value
      const ticketList: TicketListDetail | undefined = ticketListUuid
        ? ticketLists.find(
            (ticketList: TicketListDetail) =>
              ticketList.uuid === getUiStateResponse.json.value
          )
        : undefined

      const detail: UnsavedTicketDetail = {
        uuid: generateUuid(),
        wbsItem: {
          uuid: newRow.body!.wbsItem.uuid!,
          code: newRow.body!.wbsItem.code!,
          projectUuid: projectUuid,
          status: newRow.body!.wbsItem.status!,
          type: newRow.body!.wbsItem.type,
          ticketType: newRow.body!.wbsItem.ticketType!,
        },
        ticketList: ticketList
          ? {
              uuid: ticketList.uuid,
              code: ticketList.wbsItem.code,
              wbsItemUuid: ticketList.wbsItem.uuid,
              ticketType: ticketList.ticketType,
              projectUuid: projectUuid,
              displayName: ticketList.wbsItem.displayName,
            }
          : undefined,
        parentWbsItem: {
          uuid: parentWbsItem.uuid,
          code: parentWbsItem.code,
          projectUuid: projectUuid,
          type: parentType.rootType,
          displayName: parentWbsItem.displayName,
          ticketType: parentWbsItem.ticketType!,
        },
        ticketType: newRow.body?.wbsItem.ticketType,
        projectPlanUuid: newRow.uuid,
      }
      openUnsavedTicketSingleSheetDialog(detail, async () => {
        if (!gridApiRef.current || !detail.wbsItem.uuid) return
        const targetRow = prevData.current.find(
          row => row.body?.wbsItem?.uuid === detail.wbsItem.uuid
        )
        if (targetRow) {
          const refreshedRows = await refreshRow(
            prevData.current,
            targetRow.treeValue
          )
          const registeredRow = refreshedRows.find(
            (row: ProjectPlanNewRow) => row.uuid === targetRow.uuid
          )
          if (!registeredRow) {
            deleteCumulationFromAncestors([targetRow])
          } else {
            if (
              registeredRow.body &&
              registeredRow.body.wbsItem.ticketType &&
              registeredRow.body.wbsItem.ticketListUuid
            ) {
              uiStates.update({
                key: getLastSelectTicketListUiStateKey(
                  registeredRow.body.wbsItem.ticketType
                ),
                scope: UiStateScope.User,
                value: registeredRow.body.wbsItem.ticketListUuid,
              })
            }
            gridApiRef.current.getRowNode(parentUuid)?.setExpanded(true)
            focusRow(gridApiRef.current, newRow.uuid)
          }
          if (hasRequiredSaveData) {
            store.dispatch(requireSave())
          }
        }
      })
    },
    [
      edited,
      projectUuid,
      prevData,
      setData,
      addCumulationToAncestors,
      deleteCumulationFromAncestors,
      refreshRow,
      getLastSelectTicketListUiStateKey,
    ]
  )

  if (!pageState.initialized || !bulkSheetState.initialized) {
    return <></>
  }

  return (
    <PageArea>
      {layers.size === 1 && (
        <SavePopper
          loading={loading}
          onSubmit={onSubmit}
          changeLength={changeLength}
          hasTooManyChange={hasTooManyChange}
          takeMinutesToSave={
            limitChangeLength !== undefined &&
            changeLength > limitChangeLength * 2
              ? true
              : false
          }
        />
      )}
      {rootProjectPlanUuid && (
        <ProjectPlanNewBreadcrumb
          rootProjectPlanUuid={rootProjectPlanUuid}
          onSelectBreadcrumb={(event, breadcrumb) =>
            switchRootWbsItem(breadcrumb.uuid, needToOpenInNewTab(event))
          }
        />
      )}
      <ProjectPlanNewReport
        aggregateField={pageState.aggregateField}
        aggregateTarget={pageState.aggregateTarget}
        workloadUnit={pageState.workloadUnit}
        cumulation={reportCumulation}
        data={data}
        projectUuid={projectUuid}
        rootWbsItem={rootWbsItem?.uuid}
        onChangeOpenReport={pageState.setReport}
        openReport={pageState.report}
      />
      <ProjectPlanNewWbsHeader
        onChangeAggregateTarget={pageState.setAggregateTarget}
        aggregateTarget={pageState.aggregateTarget}
        onChangeAggregateField={pageState.setAggregateField}
        aggregateField={pageState.aggregateField}
        onChangeWorkloadUnit={pageState.setWorkloadUnit}
        workloadUnit={pageState.workloadUnit}
        quickFilters={quickFilters ?? undefined}
        onChangeQuickFilters={setQuickFilters}
        onChangeColumnFilter={onChangeColumnFilter}
        onSwitchingGanttChart={onSwitchingGanttChartDisplay}
        gantt={gantt}
        rowHeight={pageState.rowHeight}
        onChangeHeight={pageState.setRowHeight}
        isRowHeightFixed={isRowHeightFixed}
        onClickImportExcel={onImportExcel}
        onClickExportExcel={dialog.openExcel}
        filteredColumns={filteredColumns}
        onDeleteFilteredColumn={onDeleteFilteredColumn}
        resetFilters={resetFilters}
        onDeleteSortedColumn={onDeleteSortedColumn}
        onDeleteSortedAllColumns={onDeleteSortedAllColumns}
        onChangeSortColumnState={onChangeSortColumnState}
        onReload={onReload}
        onClickColumnSettingButton={columnSetting.toggle}
        columnSettingOpen={columnSetting.isOpen}
        onClickFavoriteColumnFilterButton={dialog.openUiState}
        sortColumnsState={sortColumnsState}
        currentFormat={pageState.dateFormat}
        onChangeDateFormat={(value: string) => pageState.setDateFormat(value)}
        onChangeOpenReport={pageState.setReport}
        openReport={pageState.report}
        rootWbsItem={rootWbsItem?.uuid}
        data={data}
        setData={setData}
        setProjectPlanBody={setProjectPlanBody}
        selectedColumnQuickFilterKey={pageState.selectedColumnQuickFilterKey}
        milestones={milestones}
        isLoadingMilestones={isLoadingMilestones}
        onRefreshMilestones={fetchMilestones}
        isMilestoneEnabled={isMilestoneEnabled}
        onRegisterMilestoneCallbacks={handleRegisterMilestoneCallbacks}
        isDependencyCriticalPathEnabled={dependencyData.isEnabled}
        onOpenCriticalPathDialog={() => setCriticalPathDialogOpen(true)}
        rootScheduledStartDate={rootWbsItem?.scheduledDate?.startDate}
        rootScheduledEndDate={rootWbsItem?.scheduledDate?.endDate}
        isProjectRoot={!treeRootUuid}
        onOptimizeGanttColumnWidth={handleOptimizeGanttColumnWidth}
      />
      <GanttChartProvider
        containerRef={ref}
        dependencies={dependencyData.dependencies}
        onDependenciesChange={dependencyData.onDependenciesChange}
        depWbsItemInfoMap={dependencyData.wbsItemInfoMap}
        criticalPaths={criticalPathData.criticalPaths}
        onCriticalPathsChange={criticalPathData.onCriticalPathsChange}
        cpWbsItemInfoMap={criticalPathData.wbsItemInfoMap}
      >
        <BulkSheetView
          ref={ref}
          gridOptions={gridOptions}
          rowData={data}
          getContextMenuItems={contextMenu}
          rowHeight={pageState.rowHeight}
          groupDefaultExpanded={groupDefaultExpanded}
          isExternalFilterPresent={isExternalFilterPresent}
          doesExternalFilterPass={doesExternalFilterPass}
          // Events and actions
          onGridReady={onGridReady}
          onFirstDataRendered={onFirstDataRendered}
          onRowGroupOpened={onRowGroupOpened}
          onColumnVisible={onColumnVisible}
          onColumnResized={rememberColumnState}
          onColumnMoved={rememberColumnState}
          onFilterChanged={onFilterChanged}
          onSortChanged={onSortChanged}
          onRowDataUpdated={onRowDataUpdated}
          onBodyScrollEnd={onBodyScrollEnd}
          onModelUpdated={onModelUpdated}
          onRowDragEnter={dragTreeStyle.onRowDragEnter}
          onRowDragMove={dragTreeStyle.onRowDragMove}
          onRowDragEnd={onRowDragEnd}
          onRowDragLeave={dragTreeStyle.refreshDragStyle}
          onCellClicked={onCellClicked}
          onCellEditingStarted={onCellEditingStarted}
          onCellDoubleClicked={onCellDoubleClicked}
          onCellValueChanged={onCellValueChanged}
          onBodyScroll={actionPopper.close}
        />
        {gridApiRef.current &&
          contextRef.current?.ganttTimeScale &&
          contextRef.current?.progressLineEnabled && (
            <ProgressLineOverlay
              gridApi={gridApiRef.current}
              timeScale={contextRef.current.ganttTimeScale}
              aggregateTarget={pageState.aggregateTarget}
              aggregateField={pageState.aggregateField}
              unit={ganttParameter.unit}
            />
          )}
        <WbsItemLinkDialog
          open={criticalPathDialogOpen}
          onClose={() => setCriticalPathDialogOpen(false)}
          type="criticalPath"
          items={criticalPathData.dialogItems}
          onUpdateLink={criticalPathData.updateLinkFromDialog}
          onRemoveLink={criticalPathData.removeLinkFromDialog}
        />
      </GanttChartProvider>
      <ColumnSettingPopper
        anchorEl={columnSetting.anchorEl}
        open={columnSetting.isOpen}
        close={columnSetting.close}
        gridApi={gridApiRef.current ?? undefined}
        height={ref.current?.offsetHeight}
        openSavedUiStateDialog={dialog.openUiState}
        initializeColumnState={() =>
          onChangeColumnFilter(ColumnQuickFilterKey.INITIAL)
        }
        applicationFunctionUuid={functionUuid}
        uiStateKey={UiStateKey.BulkSheetUIStateColumnAndFilter}
        columnState={bulkSheetState.columnState}
        offset={120}
        editorDescriptionText={
          isGanttV2
            ? intl.formatMessage({ id: 'gantt.savedUIState.description' })
            : undefined
        }
        additionalUIState={
          isGanttV2
            ? {
                ganttParameter: (
                  ganttParameter ?? GanttParameterVO.defaultValue()
                ).serialize(),
              }
            : undefined
        }
      />
      <Loading isLoading={loading} elem={ref.current} />
      {dialog.deleteConfirmation && isGridReady && (
        <DeleteRowConfirmationDialog
          target={_.uniqBy(
            getAllLeafChildren(deleteTargetNodesRef.current),
            'data.uuid'
          ).map(
            v =>
              v.data.body?.wbsItem.displayName ??
              `(${intl.formatMessage({ id: 'displayName.undefined' })})`
          )}
          onConfirm={onDeleteRows}
          onClose={dialog.closeDeleteConfirmation}
        />
      )}
      {dialog.excel && (
        <MultiSelectDialog
          onClose={dialog.closeExcel}
          onSubmit={(allList, selectedItem) => {
            const selectedColIds = selectedItem.map(col => col.value)
            onExportExcel(selectedColIds)
          }}
          dialogTitle={intl.formatMessage({
            id: 'dialog.exceloutput.columnselect.title',
          })}
          submitButtonTitle={intl.formatMessage({
            id: 'dialog.exceloutput.submit',
          })}
          allCheckBoxLabel={intl.formatMessage({
            id: 'dialog.exceloutput.columnselect.allcheckboxlabel',
          })}
          getSelectList={() => {
            return (gridApiRef.current?.getColumns() || [])
              .filter(
                column =>
                  ![
                    'uuid',
                    'drag',
                    'action',
                    'body.deliverableAttachmentSummary',
                    'ganttChart',
                  ].includes(column.getColId())
              )
              .map(column => ({
                value: column.getColId(),
                displayName: gridApiRef.current?.getDisplayNameForColumn(
                  column,
                  null
                ),
                defaultChecked:
                  column.isVisible() ||
                  [
                    'body.wbsItem.displayName',
                    'body.wbsItem.code',
                    'body.wbsItem.type',
                  ].includes(column.getColId()),
              })) as MultiSelectDialogSelection[]
          }}
          hideIcon={true}
        />
      )}
      {dialog.wbsItem && (
        <AddRowCountInputDialog
          open={true}
          title={intl.formatMessage(
            { id: 'projectPlan.add' },
            { name: dialog.wbsItemType!.name }
          )}
          submitHandler={(addRowCount: number | undefined) => {
            const rows = Array.from({ length: addRowCount ?? 0 }).map(_ =>
              createNewProjectPlanNewRow(dialog.wbsItemType!, generateCode)
            )
            const newData = addRowsToLastChild(data, rows, dialog.parentUuid)
            // ↑のdialog.parentUuidは、wbsItemではなく行のuuid
            setData(newData)
            const uuids = rows.map(v => v.uuid)
            addCumulationToAncestors(
              newData.filter(v => uuids.includes(v.uuid))
            )

            setTimeout(() => {
              gridApiRef.current
                ?.getRowNode(dialog.parentUuid)
                ?.setExpanded(true)
              if (!gridApiRef.current) return
              focusRow(gridApiRef.current, rows[0].uuid)
            }, 0)
            dialog.closeWbsItem()
          }}
          closeHandler={dialog.closeWbsItem}
        />
      )}
      {dialog.ticket && (
        <AddMultipleTicketDialog
          open={true}
          projectUuid={projectUuid}
          title={intl.formatMessage({
            id: 'bulksheet.contextMenu.ticket',
          })}
          submitHandler={(
            addRowCount?: number,
            ticketTypeCode?: string,
            ticketList?: TicketListDetail
          ) => {
            try {
              const ticketTypes = store.getState().project.ticketTypes
              const ticketType = ticketTypes.find(
                v => v.code === ticketTypeCode
              )
              if (addRowCount && ticketType && ticketList) {
                let d = data.concat()
                let firstNewUuid: string | undefined
                let uuids: string[] = []
                Array.from({ length: addRowCount }).forEach((_, i) => {
                  const newRow = createNewProjectPlanNewRow(
                    ticketType,
                    generateCode,
                    ticketList.uuid
                  )
                  if (i === 0) {
                    firstNewUuid = newRow.uuid
                  }
                  d = addRowsToLastChild(d, [newRow], dialog.parentUuid)
                  uuids.push(newRow.uuid)
                })
                setData(d)
                addCumulationToAncestors(d.filter(v => uuids.includes(v.uuid)))
                setTimeout(() => {
                  gridApiRef.current
                    ?.getRowNode(dialog.parentUuid)
                    ?.setExpanded(true)
                  gridApiRef.current &&
                    firstNewUuid &&
                    focusRow(gridApiRef.current, firstNewUuid)
                }, 0)
              }
            } finally {
              dialog.closeTicket()
            }
          }}
          closeHandler={dialog.closeTicket}
          initialValue={1}
        />
      )}
      {dialog.columnSelect && (
        <MultiSelectDialog
          onClose={dialog.closeColumnSelect}
          onSubmit={(
            allList: MultiSelectDialogSelection[],
            selectedItem: MultiSelectDialogSelection[]
          ) => {
            pasteSelectedRows(selectedItem)
            if (!gridApiRef.current) return
            const selectedNodes = getSelectedNode(gridApiRef.current)
            selectedNodes.forEach(n => n.setExpanded(true))
            dialog.closeColumnSelect()
          }}
          dialogTitle={intl.formatMessage({
            id: 'dialog.contextMenu.paste.selectedCol.title',
          })}
          submitButtonTitle={intl.formatMessage({
            id: 'dialog.contextMenu.paste.selectedCol.submit',
          })}
          allCheckBoxLabel={intl.formatMessage({
            id: 'dialog.exceloutput.columnselect.allcheckboxlabel',
          })}
          getSelectList={() => {
            const label = id => intl.formatMessage({ id: `projectPlan.${id}` })
            return [
              {
                value: 'type',
                displayName: label('type'),
                defaultChecked: true,
              },
              {
                value: 'ticketType',
                displayName: label('ticketType'),
                defaultChecked: true,
              },
              {
                value: 'displayName',
                displayName: label('displayName'),
                defaultChecked: true,
              },
              { value: 'status', displayName: label('status') },
              { value: 'substatus', displayName: label('substatus') },
              { value: 'priority', displayName: label('priority') },
              { value: 'difficulty', displayName: label('difficulty') },
              { value: 'description', displayName: label('description') },
              { value: 'team', displayName: label('team') },
              { value: 'accountable', displayName: label('accountable') },
              { value: 'responsible', displayName: label('responsible') },
              { value: 'assignee', displayName: label('assignee') },
              { value: 'estimatedHour', displayName: label('estimatedHour') },
              {
                value: 'scheduledDate.startDate',
                displayName: label('scheduledDate.start'),
              },
              {
                value: 'scheduledDate.endDate',
                displayName: label('scheduledDate.end'),
              },
              {
                value: 'actualDate.startDate',
                displayName: label('actualDate.start'),
              },
              {
                value: 'actualDate.endDate',
                displayName: label('actualDate.end'),
              },
              { value: 'tags', displayName: label('tags') },
            ]
          }}
          hideIcon={true}
          excludeValues={['type', 'ticketType', 'displayName']}
        />
      )}
      {dialog.actualResult && (
        <TaskActualWorkDialog
          open={true}
          taskUuid={dialog.taskUuid ?? ''}
          closeHandler={dialog.closeActualResult}
        />
      )}
      {dialog.cancel && (
        <CancelConfirmDialog
          open={true}
          onConfirm={() => {
            dialog.closeCancel()
            refreshAll()
          }}
          onClose={dialog.closeCancel}
        />
      )}
      {dialog.alert && (
        <AlertDialog
          isOpen={true}
          title={intl.formatMessage({
            id: 'projectPlan.switchRoot.confirmation.title',
          })}
          message={intl.formatMessage({
            id: 'projectPlan.switchRoot.confirmation.message',
          })}
          submitButtonTitle={intl.formatMessage({ id: 'dialog.ok' })}
          submitHandler={onConfirmSwitchRootWbsItem}
          closeButtonTitle={intl.formatMessage({ id: 'dialog.cancel' })}
          closeHandler={onCancelSwitchRootWbsItem}
        />
      )}
      {dialog.uiState && (
        <SavedUIStateDialog
          applicationFunctionUuid={functionUuid}
          open={true}
          title={intl.formatMessage({
            id: 'savedUIState.BULK_SHEET_UI_STATE_COLUMN_AND_FILTER',
          })}
          uiStateKey={UiStateKey.BulkSheetUIStateColumnAndFilter}
          sharable={true}
          currentUIState={savedUIStateRef.current}
          onSelect={(uiState: SavedUIState) => {
            const {
              columnState,
              filterState,
              ganttParameter: serializedGanttParameter,
            } = uiState.UIState
            if (columnState) {
              bulkSheetState.saveColumnState(columnState)
              gridApiRef.current?.applyColumnState({
                state: columnState,
                applyOrder: true,
              })
            }
            if (filterState) {
              bulkSheetState.saveFilterState(filterState)
              gridApiRef.current?.setFilterModel(filterState)
              pageState.setSelectedColumnQuickFilterKey(
                SelectedColumnQuickFilterKey.NONE
              )
            }
            if (isGanttV2 && serializedGanttParameter && projectUuid) {
              store.dispatch(
                changeGanttParameter(
                  projectUuid,
                  GanttParameterVO.deserialize(serializedGanttParameter)
                )
              )
            }
            dialog.closeUiState()
          }}
          onClose={dialog.closeUiState}
          editorDescriptionText={
            isGanttV2
              ? intl.formatMessage({ id: 'gantt.savedUIState.description' })
              : undefined
          }
        />
      )}
      <StatusChangePopper
        anchorEl={popper.anchorEl}
        projectUuid={projectUuid}
        wbsItem={popper.wbsItem}
        wbsItemDelta={popper.wbsItemDelta}
        onClose={popper.close}
        onAfterUpdate={handleWbsItemUpdate}
      />
      {actionPopper.isOpen && (
        <ActionPopper
          anchorEl={actionPopper.anchor}
          originX={actionPopper.offsetX}
          originY={actionPopper.offsetY}
          height={actionPopper.getTargetRowHeight()}
          addAboveButtonProps={actionPopper.addAboveRowButtonProps}
          addBelowButtonProps={actionPopper.addBelowRowButtonProps}
          addChildButtonProps={actionPopper.addChildRowButtonProps}
          onClose={actionPopper.close}
        />
      )}
    </PageArea>
  )
}
